import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import { TabPanel, TabView } from 'primereact/tabview';
import { useEffect, useRef, useState } from 'react';
import { setFirmResult } from '../../features/searchResultSlice';
import { setSelectedFeature } from '../../features/selectionSlice';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import './ParselInfo.scss';
import Map from 'ol/Map';
import TileLayer from 'ol/layer/Tile';
import View from 'ol/View';
import GeoJSON from 'ol/format/GeoJSON';
import WFS from 'ol/format/WFS';
import { SimpleGeometry } from 'ol/geom';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import XYZ from 'ol/source/XYZ';
import Style from 'ol/style/Style';
import Stroke from 'ol/style/Stroke';
import Fill from 'ol/style/Fill';
import { InputText } from 'primereact/inputtext';
import axios from 'axios';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Feature } from 'ol';
import { Toast } from 'primereact/toast';
import { MultiSelect } from 'primereact/multiselect';
import { useFormik } from 'formik';
import { setRefreshLayers, setShowLoading } from '../../features/sharedSlice';
import { Calendar } from 'primereact/calendar';
import { FileUpload } from 'primereact/fileupload';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { useTranslation } from 'react-i18next';
import { setFirmPopupVisibility } from '../../features/firmSlice';
import AddFirm from './AddFirm';
import { InputNumber } from 'primereact/inputnumber';
import { Checkbox } from 'primereact/checkbox';
import moment from 'moment';

export default function ParselInfo(props: any) {
  const { t } = useTranslation();
  const dispatch = useAppDispatch()
  const [activeIndex, setActiveIndex] = useState(0);
  const [olMap, setMap] = useState<any>(null);
  const [displayTabs, setDisplayTabs] = useState<boolean>(true)
  const [activeFirmaIndex, setActiveFirmaIndex] = useState(0);
  const [firmaInfo, setFirmaInfo] = useState<any>(null);
  const [ruhsatInfo, setRuhsatInfo] = useState<any>(null);
  const [ruhsatPassive, setRuhsatPassive] = useState<any>(null);
  const [tahsisInfo, setTahsisInfo] = useState<any>(null);
  const [updateFirm, setUpdateFirm] = useState<boolean>(false);
  const [selectedFirma, setSelectedFirma] = useState<any>(null);
  const [originalFirma, setOriginalFirma] = useState<any>(null);
  const [selectedRuhsat, setSelectedRuhsat] = useState<any>(null);
  const [tahsisUzatmaBelgesi, setTahsisUzatmaBelgesi] = useState<any>(null);
  const [ruhsatUzatmaBelgesi, setRuhsatUzatmaBelgesi] = useState<any>(null);
  const [previewTahsisBelge, setPreviewTahsisBelge] = useState<any>(false);
  const [previewRuhsatBelge, setPreviewRuhsatBelge] = useState<any>(false);
  const [parselBilgiEdit, setParselBilgiEdit] = useState<any>(false);
  const [tahsisBilgiEdit, setTahsisBilgiEdit] = useState<any>(false);
  const [service, setService] = useState<any>();
  const [updateState, setUpdateState] = useState<any>();
  const [zoneEdit, setZoneEdit] = useState<boolean>(false);
  const [ruhsatUzatimPanel, setRuhsatUzatimPanel] = useState<boolean>(false);
  const [ruhsatUzatimButonu, setRuhsatUzatimButonu] = useState<boolean>(false);
  const [ruhsatSureUzatim, setRuhsatSureUzatim] = useState<any>(null);
  const [ruhsatData, setRuhsatData] = useState<any>(null);
  const [ruhsatGecmisiPanel, setRuhsatGecmisiPanel] = useState(false);
  const [firmaGecmisiPanel, setFirmaGecmisiPanel] = useState(false);
  const [tahsisTarihiUzatimPanel, setTahsisTarihiUzatimPanel] = useState(false);
  const [tahsisIptalPanel, setTahsisIptalPanel] = useState(false);
  const [tahsisGecmisiPanel, setTahsisGecmisiPanel] = useState(false);
  const [tahsisSureUzatim, setTahsisSureUzatim] = useState<any>(null);
  const [tahsisUzatimButonu, setTahsisUzatimButonu] = useState(false)
  const [imarDurumu, setImarDurumu] = useState<any>(null);
  const [parselNiteligi, setParselNiteligi] = useState<any>(null);
  const [parselNiteligiTuru, setParselNiteligiTuru] = useState<any>(null);
  const [parselNiteligiTuruAcıklama, setParselNiteligiTuruAcıklama] = useState<any>(null);
  const [mulkiyetDurumu, setMulkiyetDurumu] = useState<any>(null);
  const [tahsis_durumu, setTahsisDurumu] = useState<any>(null);
  const [parselNiteligiTuruDomain, setParselNiteligiTuruDomain] = useState<any>(null);
  const [firmaTipiDomain, setFirmaTipiDomain] = useState<any>()
  const [tahsisBedelDomain, setTahsisBedelDomain] = useState<any>()
  const [tahsisUzatmaDomain, setTahsisUzatmaDomain] = useState<any>()
  const [firmaTuruDomain, setFirmaTuruDomain] = useState<any>()
  const [allNace, setAllNace] = useState<any[]>([]);
  const [ruhsatAddPanel, setRuhsatAddPanel] = useState(false)
  const [licencePdf, setLicencePdf] = useState<any>()
  const [ruhsatEklemeDomain] = useState<any>([
    { label: 'Bülten No Sorgulama', value: 1 },
    { label: 'Manuel Olarak', value: 2 }
  ])
  const [ruhsatTipiDomain, setRuhsatTipiDomain] = useState<any>()
  const [tahsisUzatimDomain, setTahsisUzatimDomain] = useState<any>()
  const [tahsisDetayAttachmentUrl, setTahsisDetayAttachmentUrl] = useState<any>()
  const [ruhsatUzatimDomain, setRuhsatUzatimDomain] = useState<any>()
  const [editToast, setEditToast] = useState<boolean>(false);
  const mapRef = useRef<any>()
  const toast = useRef<any>()
  const { feature, fields, layerInfo } = props;
  const token = useAppSelector(state => state.authState.token);
  const showEtahsis: boolean = useAppSelector(state => state.toolbarState.showEtahsis);
  const addFirmVisibility = useAppSelector(state => state.firm.addFirmVisibility)
  const [checkboxStatus, setCheckboxStatus] = useState<boolean>(false);
  const [displayTahsisBelgesi, setDisplayTahsisBelgesi] = useState<boolean>(false);
  const [tahsisUzatimSuresi, setTahsisUzatimSuresi] = useState<any>();
  const [ruhsatSuresi, setRuhsatSuresi] = useState<any>();
  const [textColor, setTextColor] = useState<any>(null);
  const [tahsisEditedProperty, setTahsisEditedProperty] = useState<any>(
    {
      tahsis_tarihi: fields.tahsis_tarihi,
      tahsis_bedel_durumu: fields.tahsis_bedel_durumu,
      tahsis_bedeli: fields.tahsis_bedeli
    });

  const iller = useAppSelector(state => state.sharedState.iller)
  const ilceler = useAppSelector(state => state.sharedState.ilceler)
  const mahalleler = useAppSelector(state => state.sharedState.mahalleler)
  const services = useAppSelector(state => state.layer.services)
  const tapuIller = useAppSelector(state => state.sharedState.tapuIller);
  const tapuIlceler = useAppSelector(state => state.sharedState.tapuIlceler);
  const tapuMahalleler = useAppSelector(state => state.sharedState.tapuMahalleler);
  const functionalRoles = useAppSelector(state => state.sharedState.functionalRoles);
  const zoneRoles = useAppSelector(state => state.sharedState.zoneRoles);
  const currentURL = window.location.href;
  const chooseOptions = { label: 'Seçiniz', icon: 'pi pi-fw pi-plus' };
  let maxDate = new Date(2007, 11, 31);
  const [maxDate2, setMaxDate2] = useState<any>(new Date(moment(fields?.tahsis_tarihi).add(730, 'days').calendar()))
  const [minDate2, setMinDate2] = useState<any>(new Date(moment(fields?.tahsis_tarihi).add(730, 'days').calendar()))
  const featureList = useAppSelector(state => state.selectionState.selectedFeatureList);

  useEffect(() => {
    if (layerInfo) {
      const asamasi = layerInfo.fields.find((obj: any) => obj.name === 'asamasi')?.domain?.find((obj: any) => obj.id === fields.asamasi)
      switch (asamasi && asamasi.id) {
        case 1:
          setTextColor('#F9CB9C')
          break;

        case 2:
          setTextColor('#FFE599')
          break;

        case 3:
          setTextColor('#A2C4C9')
          break;
        case 4:
          setTextColor('#A2C4C9')
          break;

        default:
          break;
      }
    }
  }, [layerInfo])

  //seçili olana bak
  const getFirmaInfo = async (parsel_id: number) => {

    try {
      const firmaResponse = await axios(process.env.REACT_APP_BASE_URL + `rest/v1/osb-parsel/firma2/${parsel_id}?token=${token}`)
      const firmaTipi = await axios(process.env.REACT_APP_BASE_URL + `rest/v1/domain/4420/options?token=${token}`)
      const firmaTipiArray = firmaTipi.data.options.map((obj: any) => { return { label: obj.desc, value: obj.id } })
      setFirmaTipiDomain(firmaTipiArray);
      const firmaTuru = await axios(process.env.REACT_APP_BASE_URL + `rest/v1/domain/5344/options?token=${token}`)
      const firmaTuruArray = firmaTuru.data.options.map((obj: any) => { return { label: obj.desc, value: obj.id } })
      setFirmaTuruDomain(firmaTuruArray);
      const ruhsatTipi = await axios(process.env.REACT_APP_BASE_URL + `rest/v1/domain/5345/options?token=${token}`)
      const allNaceResponse = await axios(process.env.REACT_APP_BASE_URL + `rest/v1/osb-util/allNace?token=${token}`)
      setAllNace(allNaceResponse.data.data)
      if (firmaResponse.data.data) {
        firmaResponse.data.data.forEach((firma: any) => {
          firma.firma_tipi_desc = firmaTipi.data.options.find((obj: any) => obj.id === firma.firma_tipi)?.desc
          firma.firma_turu_desc = firma.firma_turu === 2 ? `${t('TEXT.Yes')}` : `${t('TEXT.No')}`;
        });
      }
      setFirmaInfo(firmaResponse.data.data)
      const ruhsatResponse = await axios(process.env.REACT_APP_BASE_URL + `rest/v1/osb-util/ruhsat/${parsel_id}?token=${token}`)
      const ruhsatlar = ruhsatResponse.data.data?.filter((data: any) => data.active);
      const ruhsatlarPassive = ruhsatResponse.data.data?.filter((data: any) => !data.active);
      for (const ruhsat of ruhsatlar) {
        ruhsat.ruhsat_tipi_desc = ruhsatTipi.data.options.find((obj: any) => obj.id === ruhsat.ruhsat_tipi)?.desc
        if (ruhsat.ruhsat_tipi === 4) {
          downloadSelectedPdf(ruhsat);
        }
      }
      setRuhsatInfo(ruhsatlar)
      setRuhsatPassive(ruhsatlarPassive)

      const tahsisBedelTuru = await axios(process.env.REACT_APP_BASE_URL + `rest/v1/domain/8075/options?token=${token}`)

      setTahsisBedelDomain(tahsisBedelTuru.data.options)
      const uzatmaSureleriResponse = await axios(process.env.REACT_APP_BASE_URL + `rest/v1/domain/10899/options?token=${token}`)
      setTahsisUzatmaDomain(uzatmaSureleriResponse.data.options)

      const tahsisResponse = await axios(process.env.REACT_APP_BASE_URL + `rest/v1/appeal-data/42?token=${token}`)
      const tahsisler = tahsisResponse.data.data
      setTahsisInfo(tahsisler)
    } catch (error) {
      console.error(error);
    }
  }

  const getFirmaSB = async (parsel_id: number) => {
    const firmaResponse = await axios(process.env.REACT_APP_BASE_URL + `rest/v1/osb-parsel/firma/${parsel_id}?token=${token}`)
    const firmaTipi = await axios(process.env.REACT_APP_BASE_URL + `rest/v1/domain/4420/options?token=${token}`)
    const firmaTipiArray = firmaTipi.data.options.map((obj: any) => { return { label: obj.desc, value: obj.id } })
    setFirmaTipiDomain(firmaTipiArray);
    const firmaTuru = await axios(process.env.REACT_APP_BASE_URL + `rest/v1/domain/5344/options?token=${token}`)
    const firmaTuruArray = firmaTuru.data.options.map((obj: any) => { return { label: obj.desc, value: obj.id } })
    setFirmaTuruDomain(firmaTuruArray);

    const firmalar = firmaResponse.data.data;

    for (const firma of firmalar) {
      firma.firma_tipi_desc = firmaTipi.data.options.find((obj: any) => obj.id === firma.firma_tipi)?.desc
      firma.firma_turu_desc = firma.firma_turu === 2 ? `${t('TEXT.Yes')}` : `${t('TEXT.No')}`;
    }
    setFirmaInfo(firmalar);
  }

  const getParselNiteligiDomain = async (nitelik_id: number) => {
    setParselNiteligiTuru(undefined);
    try {
      let response;
      switch (nitelik_id) {
        case 2:
          response = await axios(process.env.REACT_APP_BASE_URL + `rest/v1/domain/8869/options?token=${token}`)
          break;
        case 3:
          response = await axios(process.env.REACT_APP_BASE_URL + `rest/v1/domain/8870/options?token=${token}`)
          break;
        case 4:
          response = await axios(process.env.REACT_APP_BASE_URL + `rest/v1/domain/8874/options?token=${token}`)
          break;
        case 6:
          response = await axios(process.env.REACT_APP_BASE_URL + `rest/v1/domain/8875/options?token=${token}`)
          break;
        case 7:
          response = await axios(process.env.REACT_APP_BASE_URL + `rest/v1/domain/8876/options?token=${token}`)
          break;
        default:
          break;
      }

      if (response) {
        const domain = response.data.options
        const nitelikArray = domain.map((obj: any) => { return { label: obj.desc, value: obj.id } })
        setParselNiteligiTuruDomain(nitelikArray);
      }
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    if (currentURL.includes('sb-atlas')) {
      setActiveIndex(3);
    }
    (pdfMake as any).vfs = pdfFonts.pdfMake.vfs;
    const service = services.find((obj: any) => obj.id === layerInfo.service_id);
    setService(service);

    const editZone = zoneRoles.find(obj => obj.zone_id === fields.zone_id);
    if (editZone && editZone.permission > 1) {
      setZoneEdit(true);
    }
    setImarDurumu(fields['imar_durumu'])
    setParselNiteligi(fields['parsel_niteligi'])
    if (token) {
      getParselNiteligiDomain(fields['parsel_niteligi'])
      axios(process.env.REACT_APP_BASE_URL + `rest/v1/domain/5345/options?token=${token}`).then((response) => {
        if (response) {
          const domain = response.data.options
          const tipArray = domain.map((obj: any) => { return { label: obj.desc, value: obj.id } })
          setRuhsatTipiDomain(tipArray);
        }
      }).catch((err) => {
        console.error(err);
      })
    }

    setParselNiteligiTuru(fields['parsel_nitelik_turu'])
    setMulkiyetDurumu(fields['mulkiyet_durumu'])
    setTahsisDurumu(fields['tahsis_durumu'])

    let map: Map;
    let mapInterval = setInterval(() => {
      if (mapRef.current) {
        clearInterval(mapInterval);
        const GeoJson = new GeoJSON();
        const feature: any = GeoJson.readFeature(props.feature);
        const layer = new VectorLayer({
          source: new VectorSource(),
          style: new Style({
            stroke: new Stroke({
              color: '#00000090',
              width: 2
            }),
            fill: new Fill({
              color: '#00fffe70',
            })
          })
        })
        map = new Map({
          layers: [
            new TileLayer({
              source: new XYZ({
                crossOrigin: "anonymous",
                url: 'http://mt0.google.com/vt/lyrs=s&hl=tr&x={x}&y={y}&z={z}'
              })
            }),
            layer
          ],
          target: 'parsel-map',
          view: new View({
            center: [0, 0],
            zoom: 2,
          }),
          controls: []
        });
        setMap(map);
        if (feature.getGeometry()) {
          map.getView().fit(feature.getGeometry()?.transform('EPSG:4326', 'EPSG:3857') as SimpleGeometry, { padding: [10, 10, 10, 10] })
          layer.getSource()?.addFeature(feature);
        }
        if (token) {
          getFirmaInfo(fields.id);
        } else {
          getFirmaSB(fields.id);
        }

        if (fields) {
          return () => {
            map.removeLayer(layer);
          }
        }
      }
    }, 500)

    return () => {
      setZoneEdit(false);
      if (map) {
        map.dispose();
      }
    }
  }, [fields.id])

  useEffect(() => {
    if (feature && zoneRoles && zoneRoles.length > 0) {
      const res = zoneRoles.some((zoneRole: any) => feature.properties.zone_id === zoneRole.zone_id && zoneRole.permission === 3)
      setDisplayTabs(res);
      setActiveIndex(res ? 0 : 3)
    }
  }, [feature, zoneRoles])

  useEffect(() => {
    //Tahsis tarihinin ve uzatim tarihinin kontrolu yapiliyor.
    if (fields && fields.asamasi === 1 && fields.tahsis_tarihi) {
      let firstDate: any = new Date(fields.tahsis_tarihi);
      let lastDate: any = new Date();
      let diff = Math.round((lastDate - firstDate) / (1000 * 60 * 60 * 24)); //duzelt
      let sum = 0

      if (fields.tahsis_sure_uzatim) {
        const tahsisSureUzatimArr = fields.tahsis_sure_uzatim.split(',')
        sum = tahsisSureUzatimArr.reduce(function (a: any, b: any) {
          return parseInt(a) + parseInt(b);
        });
      }

      firstDate.setFullYear(firstDate.getFullYear() + 1)

      if (diff >= 365) {

        if (fields.tahsis_sure_uzatim_tarihi && (fields.tahsis_sure_uzatim_tarihi < lastDate.toISOString()) && sum < 12) {
          setTahsisUzatimButonu(true)
          setTahsisSureUzatim(sum)
        }
        if (!fields.tahsis_sure_uzatim_tarihi && (firstDate < lastDate)) {
          setTahsisUzatimButonu(true)
          setTahsisSureUzatim(sum)
        }
      } else {
        setTahsisUzatimButonu(false)
      }
    }
  }, [fields, fields.tahsis_tarihi])

  useEffect(() => {
    //Ruhsat tarihinin ve uzatim tarihinin kontrolu yapiliyor.
    if (ruhsatInfo && fields.asamasi === 2 && !fields.ruhsat_sure_uzatim_tarihi) {

      if (ruhsatInfo.length === 1) {
        setRuhsatData(ruhsatInfo[0].ruhsat_tarihi)
      }
      if (ruhsatInfo.length > 1) {
        const filteredDateArr: any = ruhsatInfo.sort(({ ruhsat_tarihi: a }: any, { ruhsat_tarihi: b }: any) => a < b ? -1 : a > b ? 1 : 0)
        setRuhsatData(filteredDateArr[0].ruhsat_tarihi)
      }
    }
    if (ruhsatInfo && fields.asamasi === 2 && fields.ruhsat_sure_uzatim_tarihi) {
      setRuhsatData(fields)

    }
  }, [ruhsatInfo, fields])

  useEffect(() => {
    if ((ruhsatInfo && ruhsatInfo.length > 0) && ruhsatData && fields.asamasi === 2 && fields) {

      let firstDate: any = new Date(fields.ruhsat_sure_uzatim_tarihi ? fields.ruhsat_sure_uzatim_tarihi : ruhsatData);
      let lastDate: any = new Date();
      let diff: any
      let sum = 0

      if (!fields.ruhsat_sure_uzatim_tarihi) {
        diff = Math.round((lastDate - firstDate) / (1000 * 60 * 60 * 24));
      }

      if (fields.ruhsat_sure_uzatim) {
        const ruhsatSureUzatimArr = fields.ruhsat_sure_uzatim.split(',')
        sum = ruhsatSureUzatimArr.reduce(function (a: any, b: any) {
          return parseInt(a) + parseInt(b);
        });
      }

      !fields.ruhsat_sure_uzatim_tarihi ? firstDate.setFullYear(firstDate.getFullYear() + 2) : firstDate = fields.ruhsat_sure_uzatim_tarihi

      for (const ruhsat of ruhsatInfo) {

        if (ruhsat.ruhsat_tipi === 1 || ruhsat.ruhsat_tipi === 2) {
          if (fields.ruhsat_sure_uzatim_tarihi && (fields.ruhsat_sure_uzatim_tarihi < lastDate.toISOString()) && sum < 24) {
            setRuhsatUzatimButonu(true)
            setRuhsatSureUzatim(sum)
          }
          else if (!fields.ruhsat_sure_uzatim_tarihi && (firstDate < lastDate) && (diff >= 730)) {
            setRuhsatUzatimButonu(true)
            setRuhsatSureUzatim(sum)
          } else {
            setRuhsatUzatimButonu(false)
          }
        }
      }
      ruhsatInfo.sort(({ ruhsat_tarihi: a }: any, { ruhsat_tarihi: b }: any) => a < b ? -1 : a > b ? 1 : 0)[0].ruhsat_sure_uzatim_tarihi = fields.ruhsat_sure_uzatim_tarihi ? moment(fields.ruhsat_sure_uzatim_tarihi).format('DD.MM.YYYY') : '-'
    }
  }, [ruhsatData, ruhsatInfo, fields])

  useEffect(() => {
    if (fields) {
      getAttachments()
    }
  }, [fields])

  useEffect(() => {
    refreshPanel()
  }, [addFirmVisibility])

  const bodyTemplate = (rowData: any) => {
    return (
      <div className='action-buttons' style={{ textAlign: 'center' }}>
        <div key={'selection'}>
          <Button onClick={() => { setSelectedFirma(null); setSelectedFirma(rowData); setOriginalFirma(null); setOriginalFirma(rowData) }} icon="pi pi-chevron-right" className="p-button-rounded p-button-outlined" aria-label="Submit" />
        </div>
      </div>
    );
  }

  const ruhsatBodyTemplate = (rowData: any) => {
    return <Button onClick={() => { setSelectedRuhsat(rowData); }} icon="pi pi-chevron-right" className="p-button-rounded p-button-outlined" aria-label="Submit" />
  }
  const onClickKaydetParsel = async () => {

    try {
      const feature: any = new Feature()
      feature.setId(props.feature.id)
      feature.set('imar_durumu', imarDurumu);
      feature.set('parsel_niteligi', null);
      feature.set('mulkiyet_durumu', null);
      feature.set('parsel_nitelik_turu', null);
      feature.set('tahsis_durumu', null);
      feature.set('p_nitelik_turu_aciklama', null);
      if (imarDurumu === 1) {
        feature.set('parsel_niteligi', parselNiteligi);
        if (parselNiteligi === 1) {
          feature.set('mulkiyet_durumu', mulkiyetDurumu);
          if (mulkiyetDurumu === 2 || mulkiyetDurumu === 3) {
            feature.set('tahsis_durumu', 1);
          }
          else {
            feature.set('tahsis_durumu', tahsis_durumu);
          }
        } else if (parselNiteligi === 2 || parselNiteligi === 3 || parselNiteligi === 4 || parselNiteligi === 6 || parselNiteligi === 7) {
          feature.set('parsel_nitelik_turu', parselNiteligiTuru);
          feature.set('p_nitelik_turu_aciklama', parselNiteligiTuruAcıklama);
        }
      }

      if (service) {
        const wfs = new WFS()
        const xml = (wfs.writeTransaction as any)([], [feature], [], { hasZ: true, featureType: layerInfo.name, featurePrefix: service.workspace, featureNS: service.url, srsName: 'EPSG:3857' })
        var xmlText = new XMLSerializer().serializeToString(xml)
        const response = await axios.post(`${service.url}/ows?token=${token}`, xmlText, { headers: { 'Content-Type': 'text/plain' } })
        if (response.data.includes('TransactionSummary')) {
          if (parselNiteligiTuru === 8) {
            const feature: any = featureList.find((ff: any) => ff.value.id.includes('parsel_usr'))
            if (feature) {
              const properties = feature.value.properties
              const aritmaBody = {
                ada_no: properties.ada,
                parsel_no: properties.parsel,
                alan: properties.parsel_alani,
                osb_id: properties.sb_id,
                parsel_id: properties.id,
                mahalle: properties.mah_id,
                sb_id: properties.sb_id
              }
              await axios.post(process.env.REACT_APP_BASE_URL + `rest/v1/osb-osb/aritma?token=${token}`, aritmaBody)
            }
          }
          toast.current.show({ severity: 'success', summary: t('TOAST.Success'), detail: 'Öznitelikler Güncellendi.' });
          refreshPanel();
        } else {
          toast.current.show({ severity: 'error', summary: t('TOAST.Unsuccessful'), detail: 'Öznitelikler Güncellenemedi.' });
        }
      } else {
        toast.current.show({ severity: 'error', summary: t('TOAST.Unsuccessful'), detail: 'Service Bulunamadi.' });
        console.error('Service Bulunamadi');
      }

      if ((mulkiyetDurumu === 2 || tahsis_durumu === 1) && firmaInfo && firmaInfo.length === 0) {
        dispatch(setFirmPopupVisibility(true))
      }

      setParselBilgiEdit(false);
    } catch (error) {
      setParselBilgiEdit(false);
      console.error(error);
    }
  }

  const onClickKaydetTahsis = async (e: any) => {
    try {
      const feature: any = new Feature()
      feature.setId(props.feature.id)
      feature.set('tahsis_tarihi', moment(tahsisEditedProperty.tahsis_tarihi).format());
      feature.set('tahsis_bedel_durumu', tahsisEditedProperty.tahsis_bedel_durumu);
      feature.set('tahsis_bedeli', tahsisEditedProperty.tahsis_bedel_durumu !== 2 ? tahsisEditedProperty.tahsis_bedeli : null);

      if (service) {
        const wfs = new WFS()
        const xml = (wfs.writeTransaction as any)([], [feature], [], { hasZ: true, featureType: layerInfo.name, featurePrefix: service.workspace, featureNS: service.url, srsName: 'EPSG:3857' })
        var xmlText = new XMLSerializer().serializeToString(xml)
        const response = await axios.post(`${service.url}/ows?token=${token}`, xmlText, { headers: { 'Content-Type': 'text/plain' } })
        if (response.data.includes('TransactionSummary')) {
          if (e.files[0]) {
            const f: any = new FormData();
            f.append('file', e.files[0]);
            //burası
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}rest/v1/attachment/3380/${props.feature.properties.id}?token=${token}`)
            if (response.data.length > 0) {
              response.data.map((d: any) => {
                const body = { active: false }
                return axios.post(process.env.REACT_APP_BASE_URL + `rest/v1/attachment/put/${d.id}`, body, { params: { token: getToken() } });
              })
              await axios.post(`${process.env.REACT_APP_BASE_URL}rest/v1/attachment/3380/${props.feature.properties.id}/${fields.id}?token=${token}`, f)
            }
            else {
              await axios.post(`${process.env.REACT_APP_BASE_URL}rest/v1/attachment/3380/${props.feature.properties.id}/${fields.id}?token=${token}`, f)
            }
          }
          toast.current.show({ severity: 'success', summary: t('TOAST.Success'), detail: 'Öznitelikler Güncellendi.' });
          refreshPanel();
        } else {
          toast.current.show({ severity: 'error', summary: t('TOAST.Unsuccessful'), detail: 'Öznitelikler Güncellenemedi.' });
        }
      } else {
        toast.current.show({ severity: 'error', summary: t('TOAST.Unsuccessful'), detail: 'Service Bulunamadi.' });
        console.error('Service Bulunamadi');
      }

      setTahsisBilgiEdit(false);
    } catch (error) {
      setTahsisBilgiEdit(false);
      console.error(error);
    }
  }

  const naceOptionTemplate = (option: any) => {
    return (
      <div style={{ maxWidth: '200px' }}>
        {`${option.nacerev2} - ${option.nacerev2tanim}`}
      </div>
    );
  }

  const ruhsatFormik = useFormik({
    validateOnMount: true,
    initialValues: {
      bulten_no: undefined,
      ruhsat_tipi: undefined,
      ruhsat_ekleme_tipi: undefined,
      ruhsat_tarihi: new Date(2007, 1, 1)
    },
    onSubmit: () => { },
    validateOnChange: true,
    validateOnBlur: true
  });

  const isFormFieldValid = (name: string, form: any) => !!(form.touched[name] && form.errors[name]);
  const getFormErrorMessage = (name: string, form: any) => {
    return isFormFieldValid(name, form) && <small className="p-error">{form.errors[name]}</small>;
  };

  const ruhsatSorgula = async () => {
    dispatch(setShowLoading(true));
    try {
      const licenceBody = {
        bulletinNo: ruhsatFormik.values.bulten_no,
        licenceType: ruhsatFormik.values.ruhsat_tipi
      };
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}rest/v1/external-services/bstb/licence`, licenceBody, { params: { token } })
      const result: any = response.data.result;
      setLicencePdf(result);
      dispatch(setShowLoading(false));
    } catch (error) {
      toast.current.show({ severity: 'error', summary: t('TOAST.Unsuccessful'), detail: 'Ruhsat Bulunamadı.' });
      dispatch(setShowLoading(false));

    }
  }

  const onClickAddLicence = async (licencePdf: any) => {
    const body: any = {
      ruhsat_tipi: Number(ruhsatFormik.values.ruhsat_tipi),
      parsel_id: fields.id,
      bulten_no: Number(ruhsatFormik.values.bulten_no),
      attachment: licencePdf.pdfBase,
      active: true
    }
    let dateArray;
    let date;
    const tzoffset = (new Date()).getTimezoneOffset() * 60000;
    try {
      dispatch(setShowLoading(true));
      switch (Number(ruhsatFormik.values.ruhsat_tipi)) {
        case 1:
          dateArray = licencePdf.licenceApproveDate?.split('.')
          date = new Date(dateArray[2], dateArray[1] - 1, dateArray[0])
          body.ruhsat_tarihi = new Date(date.getTime() - tzoffset).toISOString()
          break;
        case 2:
          dateArray = licencePdf.documentApproveDate?.split('.')
          date = new Date(dateArray[2], dateArray[1] - 1, dateArray[0])
          body.ruhsat_tarihi = new Date(date.getTime() - tzoffset).toISOString()
          break;
        case 3:
          dateArray = licencePdf.formApproveDate?.split('.')
          date = new Date(dateArray[2], dateArray[1] - 1, dateArray[0])
          body.ruhsat_tarihi = new Date(date.getTime() - tzoffset).toISOString()
          break;

        default:
          break;
      }
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}rest/v1/osb-parsel/ruhsat?token=${token}`, body)
      if (response) {
        try {
          const feature: any = new Feature()
          feature.setId(props.feature.id)
          if (fields.asamasi === 1) {
            feature.set('asamasi', 2);
          }
          if (token) {
            getFirmaInfo(fields.id);
          } else {
            getFirmaSB(fields.id);
          }
          if (service) {
            const wfs = new WFS()
            const xml = (wfs.writeTransaction as any)([], [feature], [], { hasZ: true, featureType: layerInfo.name, featurePrefix: service.workspace, featureNS: service.url, srsName: 'EPSG:3857' })
            var xmlText = new XMLSerializer().serializeToString(xml)
            const response = await axios.post(`${service.url}/ows?token=${token}`, xmlText, { headers: { 'Content-Type': 'text/plain' } })
            if (response.data.includes('TransactionSummary')) {
              toast.current.show({ severity: 'success', summary: t('TOAST.Success'), detail: 'Parsel İnşaat Aşamasına Geçti.' });
              setRuhsatAddPanel(false);
              refreshPanel();
            } else {
              toast.current.show({ severity: 'error', summary: t('TOAST.Unsuccessful'), detail: 'Parsel İnşaat Aşamasına Geçemedi.' });
            }
          } else {
            toast.current.show({ severity: 'error', summary: t('TOAST.Unsuccessful'), detail: 'Service Bulunamadi.' });
            console.error('Service Bulunamadi');
          }
          setParselBilgiEdit(false);
        } catch (error) {
          setParselBilgiEdit(false);
          console.error(error);
        }
      }

      const ruhsatTipi = await axios(process.env.REACT_APP_BASE_URL + `rest/v1/domain/5345/options?token=${token}`)
      const ruhsatResponse = await axios(process.env.REACT_APP_BASE_URL + `rest/v1/osb-util/ruhsat/${fields.id}?token=${token}`)
      const ruhsatlar: any = ruhsatResponse.data.data

      for (const ruhsat of ruhsatlar) {
        ruhsat.ruhsat_tipi_desc = ruhsatTipi.data.options.find((obj: any) => obj.id === ruhsat.ruhsat_tipi)?.desc
      }

      setRuhsatInfo(ruhsatlar)
      dispatch(setShowLoading(false));
      setLicencePdf(undefined); ruhsatFormik.resetForm(); setRuhsatAddPanel(false);
    } catch (error) {
      console.error(error);
      dispatch(setShowLoading(false));
    }
  }

  const firmInfoUpdate = async () => {
    if (selectedFirma.mersis_no === 'undefined' || selectedFirma.mersis_no === null) {
      if (selectedFirma.vergi_no && selectedFirma.sicil_no) {
        dispatch(setShowLoading(true))
        const response = await axios(process.env.REACT_APP_BASE_URL + `rest/v1/osb-util/firmaInfoByVergiNo/${selectedFirma.vergi_no}/${selectedFirma.sicil_no}?token=${getToken()}`)
        const newFirma = response.data.data;

        setSelectedFirma({
          ...selectedFirma,
          mersis_no: newFirma.MersisNo,
          sicil_no: newFirma.SicilNo,
          vergi_no: newFirma.VergiNo,
          vergi_dairesi: newFirma.VergiDairesi,
          firma_adi: newFirma.Unvani,
        })
        dispatch(setShowLoading(false))
      }
      else {
        (toast.current as any)?.show({ severity: 'error', summary: 'Başarısız', detail: 'Firma bilgisi güncellenemedi.', life: 5000 });
      }
    }
    else {
      dispatch(setShowLoading(true))
      const response = await axios(process.env.REACT_APP_BASE_URL + `rest/v1/osb-util/firmaInfoByMersis/${selectedFirma.mersis_no}?token=${getToken()}`)
      const newFirma = response.data.data;
      setSelectedFirma({
        ...selectedFirma,
        mersis_no: newFirma.MersisNo,
        sicil_no: newFirma.SicilNo,
        vergi_no: newFirma.VergiNo,
        vergi_dairesi: newFirma.VergiDairesi,
        firma_adi: newFirma.Unvani,
      })
      dispatch(setShowLoading(false))
    }

  }
  const headerTemplate = (options: any) => {
    const { className, chooseButton } = options;

    return (
      <div className={className} style={{ backgroundColor: 'transparent', display: 'flex', alignItems: 'center' }}>
        {chooseButton}
      </div>
    );
  }

  const readFileAsync = (file: File) => {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    })
  }

  const fileUploadRef = useRef(null);
  const tahsisUploadRef = useRef(null);
  const tahsisIptalUploadRef = useRef(null);
  const ruhsatUzatimUploadRef = useRef(null);
  const upload = useRef(null);

  const ruhsatTetikleme = () => {
    (fileUploadRef.current as any).upload();
  }

  const ruhsatUzatimTetikleme = () => {
    (ruhsatUzatimUploadRef.current as any).upload();
  }
  const ruhsatUzatimEkle = async (e: any) => {
    try {
      const file = e.files[0]
      if (file) {

        const wfs = new WFS();

        const feature: any = new Feature()
        feature.setId(props.feature.id)
        feature.set('ruhsat_sure_uzatim_tarihi', ruhsatSuresi.toISOString());
        const xml = (wfs.writeTransaction as any)([], [feature], [],
          { hasZ: true, featureType: layerInfo.name, featurePrefix: service.workspace, featureNS: service.url, srsName: 'EPSG:3857' })
        let xmlText = new XMLSerializer().serializeToString(xml);
        const response = await axios.post(`${service.url}/ows?token=${token}`, xmlText, { headers: { 'Content-Type': 'text/plain' } })
        if (response.data.includes('TransactionSummary')) {
          const formData: any = new FormData();
          formData.append('file', file);
          const attachmentResponse = await axios.post(`${process.env.REACT_APP_BASE_URL}rest/v1/attachment/${layerInfo.id}/${props.feature.properties.id}/10853?token=${token}`, formData);
          if (!attachmentResponse) {
            (toast.current as any)?.show({ severity: 'error', summary: 'Başarısız', detail: 'İşlem Başarısız, Yüklediğiniz Dosyayı Kontrol Ediniz.', life: 5000 });
            setRuhsatUzatimPanel(false);
          }
          setRuhsatUzatimPanel(false);
          refreshPanel();
        } else {
          (toast.current as any)?.show({ severity: 'error', summary: 'Başarısız', detail: 'İşlem Başarısız.', life: 5000 });
          setRuhsatUzatimPanel(false);
        }

      } else {
        (toast.current as any)?.show({ severity: 'error', summary: 'Başarısız', detail: 'Dosya Zorunludur.', life: 5000 });
      }

    } catch (error) {
      console.error(error);
      (toast.current as any)?.show({ severity: 'error', summary: 'Başarısız', detail: 'İşlem Başarısız.', life: 5000 });
      setRuhsatUzatimPanel(false);
    }
  }

  const ruhsatEkle = async (e: any) => {

    try {
      const body: any = {
        active: true,
        ruhsat_tipi: ruhsatFormik.values.ruhsat_tipi,
        parsel_id: fields.id,
        bulten_no: ruhsatFormik.values.bulten_no,
        ruhsat_tarihi: ruhsatFormik.values.ruhsat_tarihi ? moment(ruhsatFormik.values.ruhsat_tarihi).format() : undefined
      }

      if (e.files[0]) {
        const base64 = await readFileAsync(e.files[0]);
        const attachment = (base64 as string)?.split(',')[1]
        body.attachment = attachment;
      }
      const addRuhsatResponse = await axios.post(`${process.env.REACT_APP_BASE_URL}rest/v1/osb-parsel/ruhsat?token=${token}`, body)

      if (addRuhsatResponse) {
        try {
          const feature: any = new Feature()
          feature.setId(props.feature.id)
          if (fields.asamasi === 1) {
            feature.set('asamasi', 2);
          }
          if (token) {
            getFirmaInfo(fields.id);
          } else {
            getFirmaSB(fields.id);
          }
          if (service) {
            const wfs = new WFS()
            const xml = (wfs.writeTransaction as any)([], [feature], [], { hasZ: true, featureType: layerInfo.name, featurePrefix: service.workspace, featureNS: service.url, srsName: 'EPSG:3857' })
            var xmlText = new XMLSerializer().serializeToString(xml)
            const response = await axios.post(`${service.url}/ows?token=${token}`, xmlText, { headers: { 'Content-Type': 'text/plain' } })
            if (response.data.includes('TransactionSummary')) {
              toast.current.show({ severity: 'success', summary: t('TOAST.Success'), detail: 'Parsel İnşaat Aşamasına Geçti.' });
              setRuhsatAddPanel(false);
              refreshPanel();
            } else {
              toast.current.show({ severity: 'error', summary: t('TOAST.Unsuccessful'), detail: 'Parsel İnşaat Aşamasına Geçemedi.' });
            }
          } else {
            toast.current.show({ severity: 'error', summary: t('TOAST.Unsuccessful'), detail: 'Service Bulunamadi.' });
            console.error('Service Bulunamadi');
          }
          setParselBilgiEdit(false);
        } catch (error) {
          setParselBilgiEdit(false);
          console.error(error);
        }
      }
      refreshPanel();
      setRuhsatAddPanel(false);
    } catch (error) {
      console.error(error);
    }
  }

  const tahsisUzatimiVer = () => {
    (tahsisUploadRef.current as any).upload();
  }
  const tahsisiIptalEt = () => {
    (tahsisIptalUploadRef.current as any).upload();
  }
  const uploadHandler = () => {
    (upload.current as any).upload();
  }

  const tahsisUzatimi = async (e: any) => {
    try {
      if (e.files.length > 0) {
        const wfs = new WFS();
        const feature: any = new Feature()
        feature.set('tahsis_sure_uzatim_tarihi', tahsisUzatimSuresi.toISOString());
        feature.setId(props.feature.id)
        const xml = (wfs.writeTransaction as any)([], [feature], [],
          { hasZ: true, featureType: layerInfo.name, featurePrefix: service.workspace, featureNS: service.url, srsName: 'EPSG:3857' })
        var xmlText = new XMLSerializer().serializeToString(xml)

        const response = await axios.post(`${service.url}/ows?token=${token}`, xmlText, { headers: { 'Content-Type': 'text/plain' } })
        if (response.data.includes('TransactionSummary')) {
          (toast.current as any)?.show({ severity: 'success', summary: 'Başarılı.', detail: 'Veri Aktarımı Başarılı.', life: 5000 });

          if (e) {
            const f: any = new FormData();
            f.append('file', e.files[0]);

            const attachmentResponse = await axios.post(`${process.env.REACT_APP_BASE_URL}rest/v1/attachment/3380/${props.feature.properties.id}/10855?token=${token}`, f)
            if (!attachmentResponse) {
              (toast.current as any)?.show({ severity: 'error', summary: 'Başarısız', detail: 'İşlem Başarısız, Yüklediğiniz Dosyayı Kontrol Ediniz.', life: 5000 });
              setTahsisTarihiUzatimPanel(false)
            }
          }
          setTahsisTarihiUzatimPanel(false)
          refreshPanel();
        }
      } else {
        (toast.current as any)?.show({ severity: 'error', summary: 'Uyarı', detail: 'Dosya Zorunludur.', life: 5000 });
      }

    } catch (error) {
      console.log(error)
      setTahsisTarihiUzatimPanel(false)
    }
  }

  const refreshPanel = async () => {
    try {
      if (service && service.url && fields.id) {
        const featuresResponse: any = await axios(`${service.url}/ows?service=WFS&version=1.0.0&request=getfeature` + (token ? `&token=${token}` : '') + `&typeName=osb%3Aparsel_usr&maxFeatures=1&outputFormat=application/json&featureID=${fields.id}`)
        const feature: any = featuresResponse.data.features[0]
        if (feature) {
          dispatch(setSelectedFeature(feature))
          dispatch(setRefreshLayers(Date.now()))
        }
      }
    } catch (error) {
      console.error(error);
      toast.current.show({ severity: 'error', summary: t('TOAST.Error'), detail: 'Parsel Bilgileri Yenilenemedi.' });
    }
  }

  const confirmRuhsatDelete = (ruhsat_id: number) => {
    confirmDialog({
      message: 'Ruhsatı Silmek İstediğinize Emin Misiniz?',
      header: 'Onay',
      icon: 'pi pi-exclamation-triangle',
      accept: () => deleteRuhsat(ruhsat_id),
      acceptLabel: `${t('TEXT.Yes')}`,
      rejectLabel: `${t('TEXT.No')}`
    });
  }

  const deleteRuhsat = async (ruhsat_id: number) => {
    try {
      const body = { active: false }

      await axios.post(`${process.env.REACT_APP_BASE_URL}rest/v1/osb-parsel/put/ruhsat/${ruhsat_id}?token=${token}`, body);
      refreshPanel();
      setSelectedRuhsat(undefined);
      if (token) {
        getFirmaInfo(fields.id);
      } else {
        getFirmaSB(fields.id);
      }
    } catch (error) {
      console.error(error);
    }
  }

  const deleteTahsis = async (e: any) => {
    if (e) {

      try {
        const wfs = new WFS();
        const feature: any = new Feature()

        feature.setId(props.feature.id)
        feature.set('tahsis_tarihi', null);
        feature.set('tahsis_iptal_tarihi', new Date().toISOString());
        feature.set('tahsis_bedel_durumu', null);
        feature.set('tahsis_bedeli', null);
        feature.set('asamasi', null);
        feature.set('tahsis_durumu', 2);
        feature.set('tahsis_sure_uzatim', null);
        feature.set('tahsis_sure_uzatim_tarihi', null);
        const xml = (wfs.writeTransaction as any)([], [feature], [],
          { hasZ: true, featureType: layerInfo.name, featurePrefix: service.workspace, featureNS: service.url, srsName: 'EPSG:3857' })
        var xmlText = new XMLSerializer().serializeToString(xml)

        try {
          const response = await axios.post(`${service.url}/ows?token=${token}`, xmlText, { headers: { 'Content-Type': 'text/plain' } })

          if (response.data.includes('TransactionSummary')) {
            (toast.current as any)?.show({ severity: 'success', summary: 'Tahsis İptali Başarılı.', detail: 'Tahsis İptali Başarılı.', life: 5000 });
            const putbody = {
              active: false
            }
            // try {
            //   const ruhsatResponse = await axios.put(process.env.REACT_APP_BASE_URL + `rest/v1/osb-parsel/ruhsat/${props.feature.properties.id}?token=${token}`, putbody)
            // } catch (error) { }
            try {
              for (const firma of firmaInfo) {
                await axios.post(process.env.REACT_APP_BASE_URL + `rest/v1/osb-parsel/put/parselFirma/${firma.parsel_firma_id}?token=${token}`, putbody)
              }
            } catch (error) { }
            try {
              if (e) {
                const f: any = new FormData();
                f.append('file', e.files[0]);

                const attachmentResponse = await axios.post(`${process.env.REACT_APP_BASE_URL}rest/v1/attachment/3380/${props.feature.properties.id}/10855?token=${token}`, f)
                if (!attachmentResponse) {
                  (toast.current as any)?.show({ severity: 'error', summary: 'Başarısız', detail: 'İşlem Başarısız, Yüklediğiniz Dosyayı Kontrol Ediniz.', life: 5000 });
                  setTahsisIptalPanel(false)
                }
              }
            } catch (error) { }
            refreshPanel();
            setTahsisIptalPanel(false)
          }
        } catch (error) {
          (toast.current as any)?.show({ severity: 'error', summary: 'Başarısız', detail: 'Tahsis İptali Başarısız.', life: 5000 });
        }
        refreshPanel();
      }
      catch {
        (toast.current as any)?.show({ severity: 'error', summary: 'Başarısız', detail: 'Tahsis İptali Başarısız.', life: 5000 });
      }
    } else {
      (toast.current as any)?.show({ severity: 'error', summary: 'Başarısız', detail: 'Dosya Zorunludur.', life: 5000 });
    }
  }

  const downloadSelectedPdf = async (selectedRuhsat: any) => {
    const tarih = selectedRuhsat.verilis_tarihi ? new Date(selectedRuhsat.verilis_tarihi)?.toLocaleDateString() : selectedRuhsat.ruhsat_tarihi
    const docDefinition: any = {
      content: [
        { text: 'Parsel Genel Bilgileri', fontSize: 15, margin: [0, 0, 0, 20] },
        { text: `Taşınmaz No: ${fields.tasinmaz_no}`, fontSize: 15, margin: [0, 0, 0, 15] },
        { text: `İl: ${tapuIller?.find((obj: any) => obj.id === fields.tkgm_il_kodu)?.ad}`, fontSize: 15, margin: [0, 0, 0, 15] },
        { text: `İlçe: ${tapuIlceler?.find((obj: any) => obj.id === fields.tkgm_ilce_kodu)?.ad}`, fontSize: 15, margin: [0, 0, 0, 15] },
        { text: `Mahalle/Köy: ${tapuMahalleler?.find((obj: any) => obj.id === fields.tkgm_mahalle_kodu)?.ad}`, fontSize: 15, margin: [0, 0, 0, 15] },
        { text: `Ada/Parsel: ${fields.ada} / ${fields.parsel}`, fontSize: 15, margin: [0, 0, 0, 15] },
        { text: `Tapu Alanı(m2): ${fields.parsel_alani?.toFixed(2)}`, fontSize: 15, margin: [0, 0, 0, 50] },
        { text: `İşyeri Açma ve Çalışma Ruhsat Bilgileri`, fontSize: 15, margin: [0, 0, 0, 20] },
        { text: `Firma Adı: ${selectedRuhsat.firma_adi ? selectedRuhsat.firma_adi : ''}`, fontSize: 15, margin: [0, 0, 0, 15] },
        { text: `Nace Kodu: ${selectedRuhsat.ruhsat_nace_kodu ? selectedRuhsat.ruhsat_nace_kodu : ''}`, fontSize: 15, margin: [0, 0, 0, 15] },
        { text: `Üretim Konusu: ${selectedRuhsat.uretim_konusu ? selectedRuhsat.uretim_konusu : ''}`, fontSize: 15, margin: [0, 0, 0, 15] },
        { text: `Belgenin Veriliş Tarihi: ${tarih}`, fontSize: 15, margin: [0, 0, 0, 15] },
        { text: `Belgeyi Onaylayan: ${selectedRuhsat.belgeyi_onaylayan ? selectedRuhsat.belgeyi_onaylayan : ''}`, fontSize: 15, margin: [0, 0, 0, 15] },
        { text: `Belgeyi İmzalayan: ${selectedRuhsat.belgeyi_imzalayan ? selectedRuhsat.belgeyi_imzalayan : ''}`, fontSize: 15, margin: [0, 0, 0, 15] }
      ]
    }

    const pdf = pdfMake.createPdf(docDefinition);
    pdf.getBase64((result) => {
      selectedRuhsat.attachment = result;
    });

  }

  const onClickUpdateFirmRuhsat = async () => {
    try {
      const firmaRuhsatResponse = await axios(process.env.REACT_APP_BASE_URL + `rest/v1/osb-util/firma/ruhsat/${selectedFirma.id}/${selectedFirma.parsel_id}?token=${token}`)
      const data = firmaRuhsatResponse.data.data
      const body = {
        ruhsat_tipi: 4,
        parsel_id: selectedFirma.parsel_id,
        firma_id: selectedFirma.firma_id,
        uretim_konusu: selectedFirma.uretim_konusu,
        ruhsat_nace_kodu: selectedFirma.ruhsat_nace_kodu,
        firma_adi: selectedFirma.firma_ruhsat_adi,
        belgeyi_onaylayan: selectedFirma.belgeyi_onaylayan,
        belgeyi_imzalayan: selectedFirma.belgeyi_imzalayan,
        ruhsat_tarihi: moment(selectedFirma.ruhsat_tarihi).format(),
        active: true
      }

      if (data.length === 0) {
        await axios.post(process.env.REACT_APP_BASE_URL + `rest/v1/osb-parsel/ruhsat?token=${token}`, body);
        toast.current.show({ severity: 'success', summary: t('TOAST.Success'), detail: 'Firma Ruhsatı Eklendi.' });
        refreshPanel();
      } else {
        const id = data[0].id;
        await axios.post(process.env.REACT_APP_BASE_URL + `rest/v1/osb-parsel/put/ruhsat/${id}?token=${token}`, body)
        toast.current.show({ severity: 'success', summary: t('TOAST.Success'), detail: 'Firma Ruhsatı Güncellendi.' });
        refreshPanel();
      }
      const wfs = new WFS();
      const feature: any = new Feature()
      feature.setId(props.feature.id)
      feature.set('asamasi', 3);
      const xml = (wfs.writeTransaction as any)([], [feature], [],
        { hasZ: true, featureType: layerInfo.name, featurePrefix: service.workspace, featureNS: service.url, srsName: 'EPSG:3857' })
      var xmlText = new XMLSerializer().serializeToString(xml)

      const response = await axios.post(`${service.url}/ows?token=${token}`, xmlText, { headers: { 'Content-Type': 'text/plain' } })
      if (response.data.includes('TransactionSummary')) {
        cancelUpdate()
        refreshPanel();
      }
    } catch (error) {
      console.error(error);
      toast.current.show({ severity: 'error', summary: t('TOAST.Error'), detail: 'Firma Ruhsatı Güncellenemedi.' });
    }
  }
  const updateFirma = async (firma: any) => {
    const body = {
      active: true,
      adres: firma.adres,
      firma_adi: firma.firma_adi,
      firma_tipi: firma.firma_tipi,
      mersis_no: firma.mersis_no,
      sanayi_sicil_no: firma.sanayi_sicil_no,
      sgk_sicil_no: firma.sgk_sicil_no,
      sicil_no: firma.sicil_no,
      vergi_dairesi: firma.vergi_dairesi,
      vergi_no: firma.vergi_no,
    }
    await axios.post(`${process.env.REACT_APP_BASE_URL}rest/v1/osb-parsel/put/firma/${firma.firma_id}?token=${getToken()}`, body)
    toast.current.show({ severity: 'success', summary: t('TOAST.Success'), detail: 'Öznitelikler Güncellendi.' });
    getFirmaInfo(fields.id);
    setUpdateFirm(false)
  }
  const getToken = () => {
    return localStorage.getItem('token');
  };
  const deleteFirm = async () => {
    confirmDialog({
      message: 'Firma Silmek İstediğinize Emin Misiniz?',
      header: 'Onay',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        const body = { active: false }
        axios.post(`${process.env.REACT_APP_BASE_URL}rest/v1/osb-parsel/firmaParsel/passive/${selectedFirma.parsel_firma_id}?token=${token}`, body).then((res: any) => {
          setSelectedFirma(null);
          getFirmaInfo(fields.id);
        })
      },
      acceptLabel: `${t('TEXT.Yes')}`,
      rejectLabel: `${t('TEXT.No')}`
    });

  }

  const cancelUpdate = () => {
    setUpdateState(false);
    refreshPanel();
  }

  const rowClass = (data: any) => {
    const sorted = ruhsatInfo.sort(({ ruhsat_tarihi: a }: any, { ruhsat_tarihi: b }: any) => a < b ? -1 : a > b ? 1 : 0)
    return sorted[0].id === data.id && fields.asamasi === 2 ? {
      'row-error': fields.asamasi === 2 &&
        (fields.ruhsat_sure_uzatim_tarihi &&
          new Date(fields.ruhsat_sure_uzatim_tarihi) < new Date()) ||
        (!fields.ruhsat_sure_uzatim_tarihi && new Date(moment(sorted[0].ruhsat_tarihi).add(760, 'days').calendar()) < new Date())
    } : ''
  }

  const getDetay = async () => {
    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}rest/v1/attachment/3380/${props.feature.properties.id}?token=${token}`)
    if (response.data[0]?.id) {
      const ress = await axios.get(process.env.REACT_APP_BASE_URL + `rest/v1/attachment/base64/${response.data[0].id}`, { params: { token: getToken() } });
      setTahsisDetayAttachmentUrl(ress.data.data)
    }
  }

  const hideToast = () => {
    localStorage.setItem('parselEditDisplayed', 'true')
    setEditToast(false)
    if (activeIndex === 0) {
      setParselBilgiEdit(true)
    }
    if (activeIndex === 1) {
      setTahsisBilgiEdit(true)
    }
    setCheckboxStatus(false)
  }

  const lengthControl = (value: any) => {
    let copy = { ...tahsisEditedProperty }
    let sliced = value
    if (value.toString().split(',')[0].length > 10) {
      sliced = value.toString().slice(0, 10)
    }
    copy = { ...copy, tahsis_bedeli: sliced }
    setTahsisEditedProperty(copy)
  }

  useEffect(() => {
    if (props.feature) {
      getDetay()
    }
  }, [props.feature])


  const getAttachments = async () => {
    if (!window.location.href.includes('sb-atlas')) {
      let tahsisBelgeleri: any[] = []
      let ruhsatBelgeleri: any[] = []

      const attachmentResponse = await axios(process.env.REACT_APP_BASE_URL + `rest/v1/attachment/${layerInfo.id}/${fields.id}?token=${token}`)
      const attachments = attachmentResponse.data

      if (attachmentResponse && attachments.length > 0) {
        for (const attachment of attachments) {
          if (attachment.field_id === 10855) {
            const tahsisBelgeleriResponse = await axios(process.env.REACT_APP_BASE_URL + `rest/v1/attachment/base64/${attachment.id}?token=${token}`)
            tahsisBelgeleri.push(tahsisBelgeleriResponse.data.data)
          }
          if (attachment.field_id === 10853) {
            const ruhsatBelgeleriResponse = await axios(process.env.REACT_APP_BASE_URL + `rest/v1/attachment/base64/${attachment.id}?token=${token}`)
            ruhsatBelgeleri.push(ruhsatBelgeleriResponse.data.data)
          }
        }
        setTahsisUzatmaBelgesi(tahsisBelgeleri)
        setRuhsatUzatmaBelgesi(ruhsatBelgeleri)
      }
    }
  }

  const ruhsatDateTemplate = (rowData: any) => {
    return formatDate(rowData.ruhsat_tarihi);
  }
  const ruhsatTipiTemplate = (rowData: any) => {
    return ruhsatTipiDomain?.find((obj: any) => obj.value === rowData.ruhsat_tipi)?.label ? ruhsatTipiDomain?.find((obj: any) => obj.value === rowData.ruhsat_tipi)?.label : ''
  }
  const tahsisGecmisiDateTemplate = (rowData: any) => {
    return formatDate(rowData.touch_date);
  }
  const sozlesmeTuruTemplate = (rowData: any) => {
    return tahsisBedelDomain?.find((obj: any) => obj.id === rowData.sozlesme_turu)?.desc ? tahsisBedelDomain?.find((obj: any) => obj.id === rowData.sozlesme_turu)?.desc : ''
  }
  const firmaDateTemplate = (rowData: any) => {
    return rowData.touch_date ? formatDate(rowData.touch_date) : null
  }
  const firmaTipiTemplate = (rowData: any) => {
    return firmaTipiDomain?.find((obj: any) => obj.value === rowData.firma_tipi)?.label ? firmaTipiDomain?.find((obj: any) => obj.value === rowData.firma_tipi)?.label : ''
  }
  const firmaTuruTemplate = (rowData: any) => {
    return firmaTuruDomain?.find((obj: any) => obj.value === rowData.firma_turu)?.label ? firmaTuruDomain?.find((obj: any) => obj.value === rowData.firma_turu)?.label : ''
  }


  const changeFormat = (number: any) => {
    const fixedNumber = Number.parseFloat(number).toFixed(2);
    const a = String(fixedNumber).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return a ? a.replace(/.(?=[^.]*$)/, ',') : ''

  }
  const onChangeDateFormat = (field: any, e: any) => {
    const offset = e.getTimezoneOffset();
    e = new Date(e.getTime() - offset * 60 * 1000);
    return e.toISOString().split('T')[0];
  };

  const formatDate = (value: any) => {
    const date = new Date(value)
    return date.toLocaleDateString('tr-TR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  }
  return (
    <>
      {!showEtahsis && <Dialog onResizeEnd={() => { olMap?.updateSize() }} header={`${layerInfo.alias} Bilgileri`} className="feature-dialog" visible={true} modal={false} onHide={() => { dispatch(setSelectedFeature(undefined)); dispatch(setFirmResult(null)); setSelectedFirma(null); }}>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
          <div style={{ width: '48%' }}>
            <div>Parsel Harita Bilgileri</div>
            <Divider />
            <div ref={mapRef} style={{ width: '100%', height: '100%' }} id='parsel-map'></div>
          </div>
          <div style={{ width: '48%' }}>
            <div>Parsel Genel Bilgileri</div>
            <Divider />
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'space-between' }}>
              <div style={{ display: 'flex', flexDirection: 'column', width: '48%' }}>
                <div className="field">
                  <label >Taşınmaz No</label>
                  <InputText disabled value={fields.tasinmaz_no} />
                </div>
                <div className="field">
                  <label >Ada/Parsel</label>
                  <InputText disabled value={`${fields.ada} / ${fields.parsel}`} />
                </div>
                <div className="field">
                  <label >Tapu Alanı(m²)</label>
                  <InputNumber minFractionDigits={2} maxFractionDigits={2} disabled value={fields.parsel_alani?.toFixed(2)} />
                </div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', width: '48%' }}>
                <div className="field">
                  <label >İl</label>
                  <InputText disabled value={(tapuIller?.find((obj: any) => obj.id === fields.tkgm_il_kodu)?.ad)} />
                </div>
                <div className="field">
                  <label >İlçe</label>
                  <InputText disabled value={tapuIlceler?.find((obj: any) => obj.id === fields.tkgm_ilce_kodu)?.ad} />
                </div>
                <div className="field">
                  <label >Mahalle/Köy</label>
                  <InputText disabled value={tapuMahalleler?.find((obj: any) => obj.id === fields.tkgm_mahalle_kodu)?.ad} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>

          {(functionalRoles.findIndex((role: any) => role.function_id === 18) > -1 || currentURL.includes('sb-atlas')) && <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} style={{ paddingTop: '4em' }}>
            {

              displayTabs && !currentURL.includes('sb-atlas') &&
              <TabPanel header="Parsel Bilgileri">
                {layerInfo.fields.find((obj: any) => obj.name === 'asamasi')?.domain?.find((obj: any) => obj.id === fields.asamasi)?.desc && <div className="field">
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <i style={{ color: textColor ? textColor : 'white', fontSize: '1.5rem', marginRight: '0.4em' }} className="pi pi-info-circle" ></i>
                    <p style={{ color: textColor ? textColor : 'white' }}>Parsel <span>{layerInfo.fields.find((obj: any) => obj.name === 'asamasi')?.domain?.find((obj: any) => obj.id === fields.asamasi)?.desc}</span> aşamasındadır.</p>
                  </div>
                </div>}
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', width: '48%' }}>
                    <div className="field">
                      <label >İmar Durumu</label>
                      <InputText disabled value={layerInfo.fields.find((obj: any) => obj.name === 'imar_durumu')?.domain?.find((obj: any) => obj.id === fields.imar_durumu)?.desc} />
                    </div>
                    {fields.imar_durumu === 1 && <>
                      <div className="field">
                        <label >Parsel Niteliği</label>
                        <InputText disabled value={layerInfo.fields.find((obj: any) => obj.name === 'parsel_niteligi')?.domain?.find((obj: any) => obj.id === fields.parsel_niteligi)?.desc} />
                      </div>
                      {fields.parsel_niteligi !== 1 && <div className="field">
                        <label >Parsel Nitelik Türü</label>
                        <InputText disabled value={parselNiteligiTuruDomain?.find((obj: any) => obj.value === fields.parsel_nitelik_turu)?.label} />
                      </div>}
                    </>}
                    {fields.parsel_nitelik_turu && <div className="field">
                      <label >Parsel Nitelik Türü Açıklaması</label>
                      <InputText disabled value={fields.p_nitelik_turu_aciklama} />
                    </div>}
                  </div>
                  {fields.parsel_niteligi === 1 && fields.imar_durumu === 1 && <div style={{ display: 'flex', flexDirection: 'column', width: '48%' }}>
                    <div className="field">
                      <label >Mülkiyet Durumu</label>
                      <InputText disabled value={layerInfo.fields.find((obj: any) => obj.name === 'mulkiyet_durumu')?.domain?.find((obj: any) => obj.id === fields.mulkiyet_durumu)?.desc} />
                    </div>
                    {fields.mulkiyet_durumu === 1 && <div className="field">
                      <label >Tahsis Durumu</label>
                      <InputText disabled value={layerInfo.fields.find((obj: any) => obj.name === 'tahsis_durumu')?.domain?.find((obj: any) => obj.id === fields.tahsis_durumu)?.desc} />
                    </div>}
                  </div>}
                </div>
                {layerInfo.perm >= 3 && zoneEdit && layerInfo.name !== 'parsel_pasif_usr' && <Button label="Güncelle" onClick={() => {
                  localStorage.getItem('parselEditDisplayed') === 'true' ? setParselBilgiEdit(true)
                    : setEditToast(true)
                }} />}
              </TabPanel>}
            {fields.imar_durumu === 1 && fields.parsel_niteligi === 1 && fields.mulkiyet_durumu === 1 &&
              displayTabs && !currentURL.includes('sb-atlas') &&
              <TabPanel header="Tahsis Bilgileri">
                {(fields.asamasi === 1 || fields.asamasi === 2) && layerInfo.perm >= 3 && layerInfo.name !== 'parsel_pasif_usr' && <Button label="Tahsis İptal" onClick={() => { setTahsisIptalPanel(true) }} style={{ marginRight: '5px' }} />}
                {fields.asamasi === 1 && tahsisUzatimButonu && layerInfo.name !== 'parsel_pasif_usr' && layerInfo.perm >= 3 && <Button label="Proje Süre Uzatımı (60/2a)" onClick={() => { setTahsisTarihiUzatimPanel(true); setMaxDate2(new Date(moment(fields?.tahsis_tarihi).add(730, 'days').calendar())) }} className='uzatim-butonu' />}
                {fields.asamasi === 1 && tahsisUzatimButonu && layerInfo.name !== 'parsel_pasif_usr' && layerInfo.perm >= 3 && <Button label="Proje Süre Uzatımı (60/4) " onClick={() => { setTahsisTarihiUzatimPanel(true); setMaxDate2(null) }} className='uzatim-butonu' style={{ marginLeft: '5px' }} />}
                {fields.tahsis_sure_uzatim_tarihi && tahsisUzatmaBelgesi && tahsisUzatmaBelgesi.length > 0 && <Button className='uzatma-belgesi-butonu' label="Tahsis Uzatma Belgesi" onClick={() => { setPreviewTahsisBelge(true) }} style={{ margin: '0 5px' }} />}
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', fontWeight: '600', borderBottom: '1px solid #304562', padding: '14px 10px' }}>
                    <div>T. Tarihi</div>
                    {/* <div>T. İptal Tarihi</div> */}
                    <div>Tahsis Uzatım Süresi</div>
                    <div>T. Bedeli</div>
                    <div>Tahsis Belgesi</div>
                  </div>
                  <div className={fields.asamasi === 1 &&
                    ((fields.tahsis_sure_uzatim_tarihi && new Date(fields.tahsis_sure_uzatim_tarihi) < new Date()) || (!fields.tahsis_sure_uzatim_tarihi && new Date(moment(fields?.tahsis_tarihi).add(365, 'days').calendar()) < new Date()))
                    ? 'row-error' : ''} style={{ display: 'flex', justifyContent: 'space-between', width: '100%', padding: '14px 10px' }}>
                    <div style={{ width: '21%' }}><span>{fields.tahsis_tarihi && fields.tahsis_tarihi !== 'Invalid Date' ? new Date(fields.tahsis_tarihi).toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric' }) : ''}</span></div>
                    {/* <div style={{ width: '27%' }}><span>{fields.tahsis_iptal_tarihi ? new Date(fields.tahsis_iptal_tarihi).toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric' }) : ''}</span></div> */}
                    <div style={{ width: '21%' }}>{fields.tahsis_sure_uzatim_tarihi ? moment(fields.tahsis_sure_uzatim_tarihi).format('DD.MM.YYYY') : '-'}</div>
                    <div style={{ width: '21%' }}><span>{fields.tahsis_bedeli ? changeFormat(fields.tahsis_bedeli) : ''}</span></div>
                    {tahsisDetayAttachmentUrl ?
                      <Button onClick={() => setDisplayTahsisBelgesi(true)} icon="pi pi-file" className="p-button-rounded p-button-outlined" aria-label="Submit" /> : '-'
                    }
                    <Dialog className="feature-dialog" visible={displayTahsisBelgesi && tahsisDetayAttachmentUrl} modal={false} onHide={() => { setDisplayTahsisBelgesi(false) }}>
                      <iframe src={`data:application/pdf;base64,${tahsisDetayAttachmentUrl}`} title="pdf" width="600" height="800"></iframe>
                    </Dialog>
                  </div>
                </div>
                {zoneRoles.find((role: any) => role.zone_id === feature.properties.zone_id)?.permission === 3 &&
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
                    {layerInfo.perm >= 3 && zoneEdit && layerInfo.name !== 'parsel_pasif_usr' && <Button label='Güncelle' className='edit-butonu' onClick={() => {
                      localStorage.getItem('parselEditDisplayed') === 'true' ? setTahsisBilgiEdit(true)
                        : setEditToast(true)
                    }} />}
                    <Button label='Tahsis Geçmişi' className='gecmis-butonu' onClick={() => setTahsisGecmisiPanel(true)} />
                  </div>}
              </TabPanel>}
            {fields.imar_durumu === 1 && fields.parsel_niteligi === 1 &&
              displayTabs && !currentURL.includes('sb-atlas') &&
              <TabPanel header="Ruhsat Bilgileri">
                {layerInfo.perm >= 3 && zoneEdit && layerInfo.name !== 'parsel_pasif_usr' && <Button label="Ruhsat Ekle" style={{ marginRight: '10px' }} onClick={() => { setRuhsatAddPanel(true); }} />}
                {fields.asamasi === 2 && layerInfo.name !== 'parsel_pasif_usr' && layerInfo.perm >= 3 &&
                
                  (fields.ruhsat_sure_uzatim_tarihi ? 
                    (ruhsatInfo && ruhsatInfo.length > 0 && new Date(fields.ruhsat_sure_uzatim_tarihi) > new Date()):
                    (ruhsatInfo && ruhsatInfo.length > 0 && !fields.ruhsat_sure_uzatim_tarihi && new Date(moment(ruhsatInfo.sort(({ ruhsat_tarihi: a }: any, { ruhsat_tarihi: b }: any) => a < b ? -1 : a > b ? 1 : 0)[0].ruhsat_tarihi).add(760, 'days').calendar()) < new Date()) &&
                    !(ruhsatInfo && ruhsatInfo.length > 0 && !fields.ruhsat_sure_uzatim_tarihi && new Date(moment(ruhsatInfo.sort(({ ruhsat_tarihi: a }: any, { ruhsat_tarihi: b }: any) => a < b ? -1 : a > b ? 1 : 0)[0].ruhsat_tarihi).add(1460, 'days').calendar()) < new Date())  ) &&

                  <Button label="İnşaat Süre Uzatımı (60/2b)" onClick={() => { setRuhsatUzatimPanel(true); setMinDate2(new Date(moment(ruhsatInfo[0].ruhsat_tarihi).add(730, 'days').calendar())); setMaxDate2(new Date(moment(ruhsatInfo[0].ruhsat_tarihi).add(1460, 'days').calendar())) }} className='uzatim-butonu' />}
                {  (fields.ruhsat_sure_uzatim_tarihi ? 
                    (ruhsatInfo && ruhsatInfo.length > 0 && new Date(fields.ruhsat_sure_uzatim_tarihi) > new Date()):
                    (ruhsatInfo && ruhsatInfo.length > 0 && !fields.ruhsat_sure_uzatim_tarihi && new Date(moment(ruhsatInfo.sort(({ ruhsat_tarihi: a }: any, { ruhsat_tarihi: b }: any) => a < b ? -1 : a > b ? 1 : 0)[0].ruhsat_tarihi).add(1460, 'days').calendar()) < new Date()) &&
                    !(ruhsatInfo && ruhsatInfo.length > 0 && !fields.ruhsat_sure_uzatim_tarihi && new Date(moment(ruhsatInfo.sort(({ ruhsat_tarihi: a }: any, { ruhsat_tarihi: b }: any) => a < b ? -1 : a > b ? 1 : 0)[0].ruhsat_tarihi).add(2190, 'days').calendar()) < new Date())  ) &&
                  <Button label="İnşaat Süre Uzatımı (60/3)" onClick={() => { setRuhsatUzatimPanel(true); setMinDate2(new Date(moment(ruhsatInfo[0].ruhsat_tarihi).add(1460, 'days').calendar())); setMaxDate2(new Date(moment(ruhsatInfo[0].ruhsat_tarihi).add(2190, 'days').calendar())) }} className='uzatim-butonu' style={{ marginLeft: '5px' }} />
                /*  <span>
                    {fields.asamasi === 2 &&
                      <>
                        <i style={{ color: '#D94B4B', fontSize: '1.5rem', marginRight: '0.4em' }} className="pi pi-info-circle" ></i>
                        <span style={{ color: '#D94B4B', fontSize: '16px' }}>İnşaat uzatma süresi aşılmıştır</span></>}
                  </span>*/
                }
                {fields.ruhsat_sure_uzatim_tarihi && ruhsatUzatmaBelgesi && ruhsatUzatmaBelgesi.length > 0 && <Button className='uzatma-belgesi-butonu' label="İnşaat Uzatma Belgesi" onClick={() => { setPreviewRuhsatBelge(true) }} style={{ marginLeft: '5px' }} />}
                <DataTable rowClassName={rowClass} value={ruhsatInfo} responsiveLayout="scroll">
                  <Column field="ruhsat_tipi_desc" header="Ruhsat Tipi"></Column>
                  <Column field="bulten_no" header="Bülten No"></Column>
                  <Column field="ruhsat_tarihi" header="Ruhsat Tarihi" body={ruhsatDateTemplate}></Column>
                  <Column field="ruhsat_sure_uzatim_tarihi" header="Ruhsat Uzatım Tarihi"></Column>
                  <Column header="Detay" body={ruhsatBodyTemplate}></Column>
                </DataTable>
                {zoneRoles.find((role: any) => role.zone_id === feature.properties.zone_id)?.permission === 3 && <div style={{ display: 'flex', justifyContent: 'end', marginTop: '20px' }}>
                  <Button label='Ruhsat Geçmişi' className='gecmis-butonu' onClick={() => { setRuhsatGecmisiPanel(true) }} />
                </div>}
              </TabPanel>}
            {fields.imar_durumu === 1 && fields.parsel_niteligi === 1 &&
              <TabPanel header="Yatırımcı Bilgileri">
                {layerInfo.perm >= 3 && zoneEdit && layerInfo.name !== 'parsel_pasif_usr' && <Button label="Yatırımcı Ekle" onClick={() => { dispatch(setFirmPopupVisibility(true)); }} />}
                <DataTable value={firmaInfo && firmaInfo.length > 0 ? firmaInfo.filter((firma: any) => firma.active) : []} responsiveLayout="scroll">
                  <Column field="firma_tipi_desc" header="Firma Tipi"></Column>
                  <Column field="firma_adi" header="Firma Adı" bodyStyle={{ maxWidth: '30vw' }}></Column>
                  {!currentURL.includes('sb-atlas') && zoneRoles.find((role: any) => role.zone_id === feature.properties.zone_id)?.permission === 3 &&
                    <Column field="firma_turu_desc" header="Kiracı Mı ?"></Column>
                  }
                  {
                    !currentURL.includes('sb-atlas') && zoneRoles.find((role: any) => role.zone_id === feature.properties.zone_id)?.permission === 3 &&
                    <Column header="Detay" body={bodyTemplate} headerStyle={{ maxWidth: '100%' }} bodyStyle={{ maxWidth: '100%' }}></Column>
                  }
                </DataTable>
                {zoneRoles.find((role: any) => role.zone_id === feature.properties.zone_id)?.permission === 3 && <div style={{ display: 'flex', justifyContent: 'end', marginTop: '20px' }}>
                  <Button label='Firma Geçmişi' className='gecmis-butonu' onClick={() => { setFirmaGecmisiPanel(true) }} />
                </div>}
              </TabPanel>}
          </TabView>}
        </div>
      </Dialog >}
      {
        selectedFirma &&
        <Dialog header={'Firma Bilgileri'} className="feature-dialog" visible={true} modal={false} onHide={() => { setSelectedFirma(null); }}>
          <TabView activeIndex={activeFirmaIndex} onTabChange={(e) => setActiveFirmaIndex(e.index)}>
            <TabPanel header="Genel Bilgiler">
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', flexDirection: 'column', width: '48%' }}>
                  <div className="field">
                    <label >Firma Tipi</label>
                    <Dropdown disabled value={selectedFirma.firma_tipi} onChange={(e: any) => { setSelectedFirma({ ...selectedFirma, firma_tipi: e.value }) }} options={firmaTipiDomain}></Dropdown>
                  </div>
                  <div className="field tooltip-firma">
                    <span><label >Firma Adı</label>
                      {updateFirm && <i className='pi pi-refresh' style={{ marginLeft: '0.5em' }} onClick={firmInfoUpdate}></i>}
                    </span>
                    <InputText disabled value={selectedFirma.firma_adi} onChange={(e: any) => { setSelectedFirma({ ...selectedFirma, firma_adi: e.target.value }) }} />
                    <span className='tooltiptext-firma'>{selectedFirma.firma_adi}</span>
                  </div>
                  <div className="field">
                    <label >Vergi/TC No</label>
                    <InputText disabled value={selectedFirma.vergi_no} onChange={(e: any) => { setSelectedFirma({ ...selectedFirma, vergi_no: e.target.value }) }} />
                  </div>
                  <div className="field">
                    <label >Ticari Sicil No</label>
                    <InputText disabled value={selectedFirma.sicil_no} onChange={(e: any) => { setSelectedFirma({ ...selectedFirma, sicil_no: e.target.value }) }} />
                  </div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', width: '48%' }}>
                  <div className="field">
                    <label >Vergi Dairesi</label>
                    <InputText disabled value={selectedFirma.vergi_dairesi} onChange={(e: any) => { setSelectedFirma({ ...selectedFirma, vergi_dairesi: e.target.value }) }} />
                  </div>
                  <div className="field">
                    <label >Sanayi Sicil No</label>
                    <InputText disabled={!updateFirm} value={selectedFirma.sanayi_sicil_no} onChange={(e: any) => { setSelectedFirma({ ...selectedFirma, sanayi_sicil_no: e.target.value }) }} />
                  </div>
                  <div className="field">
                    <label >Mersis No</label>
                    <InputText disabled value={selectedFirma.mersis_no} onChange={(e: any) => { setSelectedFirma({ ...selectedFirma, mersis_no: e.target.value }) }} />
                  </div>
                  <div className="field">
                    <label >SGK Sicil No</label>
                    <InputText disabled={!updateFirm} value={selectedFirma.sgk_sicil_no} onChange={(e: any) => { setSelectedFirma({ ...selectedFirma, sgk_sicil_no: e.target.value }); }} />
                  </div>
                </div>
              </div>
              <div className="field">
                <label>NACE Kodu</label>
                {<div style={{ width: '413px', border: '1px solid #3045627a', borderRadius: '3px', padding: '7px', background: '#1c2839' }}>
                  {selectedFirma.firma_naceler.length > 0 && selectedFirma.firma_naceler.map((firma: any) => {
                    return (<div style={{ marginBottom: '5px' }}>
                      {firma.nace_id ? <li style={{ opacity: '.4' }}>{firma.nacerev2 + ' - ' + firma.nacerev2tanim}<br /></li> : '-'}
                    </div>)
                  })}
                </div>}
                {/*updateFirm &&
                  <MultiSelect
                    id="firmaSektoru"
                    display="chip"
                    options={allNace}
                    value={selectedFirma.firma_naceler}
                    onChange={(e) => setSelectedFirma({ ...selectedFirma, firma_naceler: e.value })}
                    optionLabel="nacerev2"
                    itemTemplate={naceOptionTemplate}
                    filter
                    showClear
                    filterBy="nacerev2,nacerev2tanim"
                    placeholder={t('FIRM.Select Nace Code') + '*'}
                />*/}
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                <div style={{ display: 'flex' }}>
                  {(layerInfo.perm === 7) && layerInfo.name !== 'parsel_pasif_usr' && !updateFirm && <Button label='Firma Güncelle' onClick={() => setUpdateFirm(true)}></Button>}
                  {(layerInfo.perm === 7) && layerInfo.name !== 'parsel_pasif_usr' && updateFirm && <Button label='Kaydet' onClick={() => updateFirma(selectedFirma)}></Button>}
                  {(layerInfo.perm === 7) && layerInfo.name !== 'parsel_pasif_usr' && updateFirm && <Button style={{ marginLeft: '0.5em' }} label='İptal' onClick={() => {
                    setUpdateFirm(false); setSelectedFirma(null);
                  }}></Button>}
                </div>
                {(layerInfo.perm === 7) && layerInfo.name !== 'parsel_pasif_usr' && <Button style={{ marginLeft: '0.5em', background: '#D94B4B', borderColor: '#D94B4B' }} label='Firma Sil' onClick={() => { deleteFirm(); }}></Button>}
              </div>
            </TabPanel>
            <TabPanel header="İletişim Bilgileri">
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', flexDirection: 'column', width: '48%' }}>
                  <div className="field">
                    <label >Telefon</label>
                    {/* <InputText disabled value={selectedFirma.telefon_no} onChange={(e: any) => { setSelectedFirma({ ...selectedFirma, telefon_no: e.target.value }) }} /> */}
                    <InputText disabled value={selectedFirma.telefon_no} onChange={(e: any) => { setSelectedFirma({ ...selectedFirma, telefon_no: e.target.value }) }} />
                  </div>
                  <div className="field">
                    <label >Cep Telefonu</label>
                    <InputText disabled value={selectedFirma.cep_telefonu} onChange={(e: any) => { setSelectedFirma({ ...selectedFirma, cep_telefonu: e.target.value }) }} />
                  </div>
                  <div className="field">
                    <label >E-Posta</label>
                    <InputText disabled value={selectedFirma.eposta} onChange={(e: any) => { setSelectedFirma({ ...selectedFirma, eposta: e.target.value }) }} />
                  </div>
                  <div className="field">
                    <label >Fax</label>
                    <InputText disabled value={selectedFirma.fax} onChange={(e: any) => { setSelectedFirma({ ...selectedFirma, fax: e.target.value }) }} />
                  </div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', width: '48%' }}>
                  <div className="field">
                    <label >İl</label>
                    <InputText disabled value={iller.find(obj => obj.id === selectedFirma.il_kodu)?.adi} />
                  </div>
                  <div className="field">
                    <label >İlçe</label>
                    <InputText disabled value={ilceler.find(obj => obj.ilce_kodu === selectedFirma.ilce_kodu)?.adi} />
                  </div>
                  <div className="field">
                    <label >Mahalle/Köy</label>
                    <InputText disabled value={mahalleler.find(obj => obj.mah_id === selectedFirma.mahalle_kodu)?.adi} />
                  </div>
                  <div className="field">
                    <label >Web Adresi</label>
                    <InputText disabled value={selectedFirma.web_adresi} onChange={(e: any) => { setSelectedFirma({ ...selectedFirma, web_adresi: e.target.value }) }} />
                  </div>
                </div>
              </div>
              {/* {(layerInfo.perm === 7) && <Button label='Güncelle' onClick={() => { onChangeSelectedFirm(); }}></Button>} */}
            </TabPanel>
            <TabPanel header="İşyeri Açma Ruhsatı Bilgileri">
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', flexDirection: 'column', width: '48%' }}>
                  <div className="field">
                    <label >Firma Adı</label>
                    <InputText maxLength={50} disabled={!(layerInfo.perm === 7 && updateState)} value={selectedFirma.firma_ruhsat_adi} onChange={(e: any) => { setSelectedFirma({ ...selectedFirma, firma_ruhsat_adi: e.target.value }) }}
                      onInput={(e: any) => {
                        e.target.value = e.target.value.substring(0, 50)
                      }}
                    />
                  </div>
                  <div className="field">
                    <label >Nace Kodu</label>
                    <MultiSelect disabled={!(layerInfo.perm === 7 && updateState)} display="chip" options={allNace} value={selectedFirma.ruhsat_nace_kodu?.split(',')}
                      onChange={(e) => { setSelectedFirma({ ...selectedFirma, ruhsat_nace_kodu: e.value.join(',') }) }}
                      optionLabel="nacerev2" optionValue='nacerev2' itemTemplate={naceOptionTemplate} filter showClear filterBy="nacerev2,nacerev2tanim" placeholder="Nace Kodu Seçiniz"
                    />
                  </div>
                  <div className="field">
                    <label >Ruhsat Tarihi</label>
                    <Calendar dateFormat="dd/mm/yy" disabled={!(layerInfo.perm === 7 && updateState)} id='ruhsat_tarihi' value={selectedFirma.ruhsat_tarihi} onChange={(e) => { setSelectedFirma({ ...selectedFirma, ruhsat_tarihi: e.target.value }) }} placeholder="dd.mm.yyyy" mask="99.99.9999" />
                  </div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', width: '48%' }}>
                  <div className="field">
                    <label >Belgeyi Onaylayan</label>
                    <InputText maxLength={50} disabled={!(layerInfo.perm === 7 && updateState)} value={selectedFirma.belgeyi_onaylayan} onChange={(e: any) => { setSelectedFirma({ ...selectedFirma, belgeyi_onaylayan: e.target.value }) }}
                      onInput={(e: any) => {
                        e.target.value = e.target.value.substring(0, 50)
                      }}
                    />
                  </div>
                  <div className="field">
                    <label >Belgeyi İmzalayan</label>
                    <InputText maxLength={50} disabled={!(layerInfo.perm === 7 && updateState)} value={selectedFirma.belgeyi_imzalayan} onChange={(e: any) => { setSelectedFirma({ ...selectedFirma, belgeyi_imzalayan: e.target.value }) }}
                      onInput={(e: any) => {
                        e.target.value = e.target.value.substring(0, 50)
                      }}
                    />
                  </div>
                  <div className="field">
                    <label >Üretim Konusu</label>
                    <InputText maxLength={50} disabled={!(layerInfo.perm === 7 && updateState)} value={selectedFirma.uretim_konusu} onChange={(e: any) => { setSelectedFirma({ ...selectedFirma, uretim_konusu: e.target.value }) }}
                      onInput={(e: any) => {
                        e.target.value = e.target.value.substring(0, 50)
                      }}
                    />
                  </div>
                </div>
              </div>
              <div style={{ marginTop: '15px' }}>
                {(!updateState) && (layerInfo.perm === 7) && layerInfo.name !== 'parsel_pasif_usr' &&
                  <Button onClick={() => setUpdateState(true)}>Güncelle</Button>}
                {updateState &&
                  <Button onClick={() => cancelUpdate()}>Güncellemeyi İptal Et</Button>}
                {updateState &&
                  <Button style={{ marginLeft: '25px' }} onClick={() => onClickUpdateFirmRuhsat()}>Kaydet</Button>}
              </div>
            </TabPanel>
          </TabView>
        </Dialog >
      }
      {
        parselBilgiEdit && <Dialog header={'Parsel Bilgileri Güncelleme'} className="feature-dialog" visible={parselBilgiEdit} modal={false} onHide={() => { setParselBilgiEdit(false); }}>
          <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            <div className="field">
              <label >İmar Durumu</label>
              <Dropdown value={imarDurumu} onChange={(e) => setImarDurumu(e.value)} options={layerInfo.fields.find((obj: any) => obj.name === 'imar_durumu')?.domain.map((obj: any) => { return { label: obj.desc, value: obj.id } })}></Dropdown>
            </div>
            {imarDurumu && imarDurumu === 1 &&
              <>
                <div className="field">
                  <label >Parsel Niteliği</label>
                  <Dropdown value={parselNiteligi} onChange={(e) => { getParselNiteligiDomain(e.value); setParselNiteligi(e.value) }} options={layerInfo.fields.find((obj: any) => obj.name === 'parsel_niteligi')?.domain.map((obj: any) => { return { label: obj.desc, value: obj.id } })}></Dropdown>
                </div>
                {
                  (parselNiteligi === 2 || parselNiteligi === 3 || parselNiteligi === 4 || parselNiteligi === 6 || parselNiteligi === 7) && parselNiteligiTuruDomain &&
                  <>
                    <div className="field">
                      <label >Parsel Nitelik Türü</label>
                      <Dropdown value={parselNiteligiTuru} onChange={(e) => { setParselNiteligiTuru(e.value) }} options={parselNiteligiTuruDomain}></Dropdown>
                    </div>
                    <div className="field">
                      <label >Parsel Nitelik Türü Açıklaması</label>
                      <InputText maxLength={50} value={parselNiteligiTuruAcıklama} onChange={(e) => { setParselNiteligiTuruAcıklama(e.target.value) }}
                        onInput={(e: any) => e.target.value = e.target.value.substring(0, 49)}
                      ></InputText>
                    </div>
                  </>
                }
                {
                  (parselNiteligi === 1) &&
                  <>
                    <div className="field">
                      <label >Mülkiyet Durumu</label>
                      <Dropdown value={mulkiyetDurumu} onChange={(e) => setMulkiyetDurumu(e.value)} options={layerInfo.fields.find((obj: any) => obj.name === 'mulkiyet_durumu')?.domain.map((obj: any) => { return { label: obj.desc, value: obj.id } })}></Dropdown>
                    </div>
                  </>
                }
                {mulkiyetDurumu === 1 &&
                  <div className="field">
                    <label >Tahsis Durumu</label>
                    <Dropdown value={tahsis_durumu} onChange={(e) => setTahsisDurumu(e.value)} options={layerInfo.fields.find((obj: any) => obj.name === 'tahsis_durumu')?.domain.map((obj: any) => { return { label: obj.desc, value: obj.id } })}></Dropdown>
                  </div>}
              </>
            }
            <Button label='Kaydet' disabled={mulkiyetDurumu === 1 && !tahsis_durumu} onClick={() => onClickKaydetParsel()}></Button>
          </div>
        </Dialog>
      }
      {
        tahsisBilgiEdit &&
        <Dialog header={'Tahsis Bilgileri Güncelleme'} className="feature-dialog" visible={tahsisBilgiEdit} modal={false} onHide={() => { setTahsisBilgiEdit(false); }}>
          <div className="field">
            <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
              <label >Tahsis Tarihi</label>
              <Calendar id='tahsis_tarihi' value={new Date(tahsisEditedProperty.tahsis_tarihi ? tahsisEditedProperty.tahsis_tarihi : tahsisInfo.tahsis_tarihi)} onChange={(e: any) => setTahsisEditedProperty({ ...tahsisEditedProperty, tahsis_tarihi: e.target.value })} dateFormat="dd/mm/yy" placeholder={`${moment().format('DD.MM.YYYY')}`} mask="99/99/9999" />
            </div>
            <div className="field">
              <label >Tahsis Bedel Durumu</label>
              <Dropdown value={tahsisBedelDomain?.find((domain: any) => tahsisEditedProperty.tahsis_bedel_durumu === domain.id)?.id} onChange={(e) => { setTahsisEditedProperty({ ...tahsisEditedProperty, tahsis_bedel_durumu: e.target.value }) }} options={tahsisBedelDomain} optionLabel='desc' optionValue='id' style={{ width: '256px' }} />
            </div>
            {tahsisEditedProperty.tahsis_bedel_durumu !== 2 && <div className="field">
              <label >Tahsis Bedeli</label>
              <InputNumber value={tahsisEditedProperty.tahsis_bedeli} minFractionDigits={2} maxFractionDigits={2} onChange={(e: any) => lengthControl(e.value)}
              ></InputNumber>
            </div>}
            <div className="field">
              <label>Tahsis Belgesi Yükle</label>
              <FileUpload customUpload
                invalidFileSizeMessageSummary='Yüksek dosya boyutu. '
                invalidFileSizeMessageDetail='Yüklediğiniz dosyanın boyutu en fazla 50 MB olabilir.'
                ref={upload} mode='advanced' headerTemplate={headerTemplate} accept='application/pdf'
                chooseOptions={chooseOptions} uploadHandler={onClickKaydetTahsis} />
            </div>
            <Button label='Kaydet' onClick={uploadHandler} />
          </div>
        </Dialog>
      }
      {
        <Dialog header={'Tahsis İptal Paneli'} className="ruhsat-dialog" visible={tahsisIptalPanel} modal={false} onHide={() => { setTahsisIptalPanel(false); }}>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'space-between' }}>
            <div className="field">
              <label>Tahsis İptal Belgesi</label>
              <FileUpload customUpload ref={tahsisIptalUploadRef} mode='advanced'
                invalidFileSizeMessageSummary='Yüksek dosya boyutu. '
                invalidFileSizeMessageDetail='Yüklediğiniz dosyanın boyutu en fazla 50 MB olabilir.'
                headerTemplate={headerTemplate} accept='application/pdf'
                chooseOptions={chooseOptions} uploadHandler={deleteTahsis} style={{ width: '256px' }} />
            </div>
            <Button label='Tahsisi İptal Et' onClick={() => tahsisiIptalEt()} type='submit' style={{ width: '256px' }} disabled={!tahsisIptalUploadRef}></Button>
          </div>
        </Dialog>
      }
      {
        <Dialog header={'Tahsis Uzatım Paneli'} className="ruhsat-dialog" visible={tahsisTarihiUzatimPanel} modal={false} onHide={() => { setTahsisTarihiUzatimPanel(false); }}>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'space-between' }}>
            <div className="field" style={{ width: '100%' }}>
              <label>Tahsis Uzatım Süresi</label>
              <Calendar onChange={(e) => setTahsisUzatimSuresi(e.target.value)} minDate={new Date(moment(fields?.tahsis_tarihi).add(365, 'days').calendar())} maxDate={maxDate2} id='tahsis_tarihi' dateFormat="dd/mm/yy" placeholder={`${moment().format('DD.MM.YYYY')}`} mask="99/99/9999" />
            </div>
            <div className="field">
              <label>Tahsis Uzatım Belgesi</label>
              <FileUpload customUpload ref={tahsisUploadRef}
                invalidFileSizeMessageSummary='Yüksek dosya boyutu. '
                invalidFileSizeMessageDetail='Yüklediğiniz dosyanın boyutu en fazla 50 MB olabilir.'
                mode='advanced' headerTemplate={headerTemplate} accept='application/pdf'
                chooseOptions={chooseOptions} uploadHandler={tahsisUzatimi} style={{ width: '256px' }} />
            </div>
            <Button label='Tahsis Uzatımı Ver' onClick={() => tahsisUzatimiVer()} type='submit' style={{ width: '256px' }} disabled={!tahsisUzatimSuresi || !tahsisUploadRef}></Button>
          </div>
        </Dialog>
      }
      {
        <Dialog header={'Tahsis Geçmişi'} className="ruhsat-dialog" visible={tahsisGecmisiPanel} modal={false} onHide={() => { setTahsisGecmisiPanel(false); }}>
          <DataTable value={tahsisInfo && tahsisInfo.length > 0 ? tahsisInfo.filter((tahsis: any) => tahsis.parsel_id === fields.id && tahsis.appeal_status_id === 2) : []} responsiveLayout="scroll">
            <Column field="tahsis_bedeli" header="Tahsis Bedeli" />
            <Column field="sozlesme_turu" header="Sözleşme Türü" body={sozlesmeTuruTemplate} />
            <Column field="touch_date" header="Tahsis Tarihi" body={tahsisGecmisiDateTemplate} />
          </DataTable>
        </Dialog>
      }
      {
        ruhsatAddPanel && <Dialog header={'Ruhsat Ekleme'} className="ruhsat-dialog" visible={ruhsatAddPanel} modal={false} onHide={() => { setLicencePdf(undefined); ruhsatFormik.resetForm(); setRuhsatAddPanel(false); }}>
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'space-between' }}>
            {!licencePdf && <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
              <div className="field">
                <label>Ruhsat Tipi</label>
                <Dropdown id="ruhsat_tipi" value={ruhsatFormik.values.ruhsat_tipi} options={ruhsatTipiDomain.filter((obj: any) => obj.value !== 4)} onChange={ruhsatFormik.handleChange} placeholder="Ruhsat Tipi Seçiniz" />
                {getFormErrorMessage('ruhsat_tipi', ruhsatFormik)}
              </div>
              <div className="field">
                <label>Ruhsat Ekleme Tipi</label>
                <Dropdown id="ruhsat_ekleme_tipi" value={ruhsatFormik.values.ruhsat_ekleme_tipi} options={ruhsatEklemeDomain} onChange={ruhsatFormik.handleChange} placeholder="Ruhsat Ekleme Tipi Seçiniz" />
              </div>
              {
                Number(ruhsatFormik.values.ruhsat_ekleme_tipi) === 1 &&
                <>
                  <div className="field">
                    <label>Bülten No</label>
                    <InputText id='bulten_no' value={(ruhsatFormik.values as any)['bulten_no']} onChange={ruhsatFormik.handleChange} onBlur={ruhsatFormik.handleBlur} />
                  </div>
                  <Button disabled={!ruhsatFormik.values.ruhsat_tipi || !ruhsatFormik.values.bulten_no} label='Ruhsat Sorgula' onClick={(e: any) => ruhsatSorgula()}></Button>
                </>
              }
              {
                Number(ruhsatFormik.values.ruhsat_ekleme_tipi) === 2 &&
                <>
                  <span style={{ display: 'flex', alignItems: 'center' }}>
                    <i className='pi pi-info-circle' style={{ marginRight: '0.5em', fontSize: '1.5rem', color: '#D94B4B' }}></i>
                    <p style={{ color: '#D94B4B' }}>Manuel ruhsat ekleme modulü yanlızca 2007 öncesi tarihli ruhsatlar için kullanılabilir.</p>
                  </span>
                  <div className="field">
                    <label>Ruhsat Onay Tarihi</label>
                    <Calendar maxDate={maxDate} id='ruhsat_tarihi' value={ruhsatFormik.values.ruhsat_tarihi} onChange={ruhsatFormik.handleChange} dateFormat="dd/mm/yy" placeholder={`${moment().format('DD.MM.YYYY')}`} mask="99/99/9999" />
                  </div>
                  <div className="field">
                    <label>Ruhsat Dosyası</label>
                    <FileUpload customUpload ref={fileUploadRef}
                      invalidFileSizeMessageSummary='Yüksek dosya boyutu. '
                      invalidFileSizeMessageDetail='Yüklediğiniz dosyanın boyutu en fazla 50 MB olabilir.'
                      mode='advanced' headerTemplate={headerTemplate} accept='application/pdf'
                      chooseOptions={chooseOptions} uploadHandler={ruhsatEkle} />
                  </div>
                  {layerInfo.name !== 'parsel_pasif_usr' && <Button disabled={!ruhsatFormik.values.ruhsat_tipi || !ruhsatFormik.values.ruhsat_tarihi} label='Ruhsat Ekle' onClick={() => ruhsatTetikleme()}></Button>}
                </>
              }
            </div>}
            {licencePdf && <div className="pdf-container">
              <iframe src={`data:application/pdf;base64,${licencePdf.pdfBase}`} title="pdf" width="600" height="800"></iframe>
              <div style={{ marginLeft: '10px' }}>
                {Number(ruhsatFormik.values.ruhsat_tipi) === 1 && <>
                  <div className="field">
                    <label>Ruhsat No</label>
                    <InputText disabled id='firmaAdi' value={licencePdf.licenceNo} />
                  </div>
                  <div className="field">
                    <label>Ruhsat Onay Tarihi</label>
                    <InputText disabled id='firmaAdi' value={licencePdf.licenceApproveDate} />
                  </div>
                  <div className="field">
                    <label>Ruhsat Geçerlilik Tarihi</label>
                    <InputText disabled id='firmaAdi' value={licencePdf.licenceValidityDate} />
                  </div>
                </>}
                {Number(ruhsatFormik.values.ruhsat_tipi) === 2 && <>
                  <div className="field">
                    <label>Belge No</label>
                    <InputText disabled id='firmaAdi' value={licencePdf.documentNo} />
                  </div>
                  <div className="field">
                    <label>Belge Onay Tarihi</label>
                    <InputText disabled id='firmaAdi' value={licencePdf.documentApproveDate} />
                  </div>
                </>}
                {Number(ruhsatFormik.values.ruhsat_tipi) === 3 && <>
                  <div className="field">
                    <label>Form No</label>
                    <InputText disabled id='firmaAdi' value={licencePdf.formNo} />
                  </div>
                  <div className="field">
                    <label>Form Onay Tarihi</label>
                    <InputText disabled id='firmaAdi' value={licencePdf.formApproveDate} />
                  </div>
                </>}
                <Button label='Ruhsatı Ekle' onClick={() => { onClickAddLicence(licencePdf) }}></Button>
              </div>
            </div>}
          </div>
        </Dialog>
      }
      {
        selectedRuhsat && <Dialog header={'Ruhsat Bilgisi'} className="ruhsat-dialog" visible={selectedRuhsat} modal={false} onHide={() => { setSelectedRuhsat(undefined); }}>
          <div className="pdf-container">
            {selectedRuhsat.attachment && <iframe src={`data:application/pdf;base64,${selectedRuhsat.attachment}`} title="pdf" width="600" height="800"></iframe>}
            <div style={{ marginLeft: '10px' }}>
              {selectedRuhsat.ruhsat_tipi === 1 && <>
                <div className="field">
                  <label>Bülten No</label>
                  <InputText disabled id='firmaAdi' value={selectedRuhsat.bulten_no} />
                </div>
                <div className="field">
                  <label>Ruhsat Onay Tarihi</label>
                  <InputText disabled id='firmaAdi' value={formatDate(selectedRuhsat.ruhsat_tarihi)} />
                </div>
              </>}
              {selectedRuhsat.ruhsat_tipi === 2 && <>
                <div className="field">
                  <label>Bülten No</label>
                  <InputText disabled id='firmaAdi' value={selectedRuhsat.bulten_no} />
                </div>
                <div className="field">
                  <label>Belge Onay Tarihi</label>
                  <InputText disabled id='firmaAdi' value={formatDate(selectedRuhsat.ruhsat_tarihi)} />
                </div>
              </>}
              {selectedRuhsat.ruhsat_tipi === 3 && <>
                <div className="field">
                  <label>Bülten No</label>
                  <InputText disabled id='firmaAdi' value={selectedRuhsat.bulten_no} />
                </div>
                <div className="field">
                  <label>Form Onay Tarihi</label>
                  <InputText disabled id='firmaAdi' value={selectedRuhsat.ruhsat_tarihi} />
                </div>
              </>}
              {selectedRuhsat.ruhsat_tipi === 4 && <>
                <div className="field">
                  <label>Firma Adı</label>
                  <InputText disabled id='firmaAdi' value={selectedRuhsat.firma_adi} />
                </div>
                <div className="field">
                  <label>Nace Kodu</label>
                  <InputText disabled id='firmaAdi' value={selectedRuhsat.ruhsat_nace_kodu} />
                </div>
                <div className="field">
                  <label>Ruhsat Tarihi</label>
                  <InputText disabled id='firmaAdi' value={selectedRuhsat.ruhsat_tarihi} />
                </div>
                <div className="field">
                  <label>Belgeyi Onaylayan</label>
                  <InputText disabled id='firmaAdi' value={selectedRuhsat.belgeyi_onaylayan} />
                </div>
                <div className="field">
                  <label>Belgeyi İmzalayan</label>
                  <InputText disabled id='firmaAdi' value={selectedRuhsat.belgeyi_imzalayan} />
                </div>
                <div className="field">
                  <label>Üretim Konusu</label>
                  <InputText disabled id='firmaAdi' value={selectedRuhsat.uretim_konusu} />
                </div>
              </>}
              <div className="field">
                <Button label='Ruhsatı Sil' style={{ background: '#D94B4B', borderColor: '#D94B4B' }} onClick={() => { confirmRuhsatDelete(selectedRuhsat.id) }}></Button>
              </div>
            </div>
          </div>
        </Dialog>
      }
      {
        <Dialog header={'Ruhsat Uzatımı'} className="ruhsat-dialog" visible={ruhsatUzatimPanel} modal={false} onHide={() => { setRuhsatUzatimPanel(false); }}>
          <div className="field">
            <label>Ruhsat Uzatım Süresi</label>
            <Calendar onChange={(e) => setRuhsatSuresi(e.target.value)} minDate={minDate2} maxDate={maxDate2} id='ruhsat_tarihi' dateFormat="dd/mm/yy" placeholder={`${moment().format('DD.MM.YYYY')}`} mask="99/99/9999" />

          </div>
          <div className="field">
            <label>Ruhsat Uzatım Dosyası</label>
            <FileUpload customUpload
              invalidFileSizeMessageSummary='Yüksek dosya boyutu. '
              invalidFileSizeMessageDetail='Yüklediğiniz dosyanın boyutu en fazla 50 MB olabilir.'
              ref={ruhsatUzatimUploadRef} mode='advanced' headerTemplate={headerTemplate} accept='application/pdf'
              chooseOptions={chooseOptions} uploadHandler={ruhsatUzatimEkle} />
          </div>
          <Button disabled={!ruhsatSuresi} label='Ruhsat Uzatımı Ver' onClick={() => ruhsatUzatimTetikleme()}></Button>
        </Dialog>
      }
      {
        <Dialog header={'Ruhsat Geçmişi'} className="ruhsat-dialog" visible={ruhsatGecmisiPanel} modal={false} onHide={() => { setRuhsatGecmisiPanel(false); }}>
          <DataTable value={ruhsatPassive} responsiveLayout="scroll">
            <Column field="ruhsat_tipi" header="Ruhsat Tipi" body={ruhsatTipiTemplate} />
            <Column field="bulten_no" header="Bülten No" />
            <Column field="ruhsat_tarihi" header="Ruhsat Tarihi" body={ruhsatDateTemplate} />
          </DataTable>
        </Dialog>
      }
      {
        <Dialog header={'Firma Geçmişi'} className="ruhsat-dialog" visible={firmaGecmisiPanel} modal={false} onHide={() => { setFirmaGecmisiPanel(false); }}>
          <DataTable value={firmaInfo && firmaInfo.length > 0 ? firmaInfo.filter((firma: any) => !firma.active) : []} responsiveLayout="scroll">
            <Column field="firma_adi" header="Firma Adı" />
            <Column field="firma_tipi" header="Firma Tipi" body={firmaTipiTemplate} />
            <Column field="firma_turu" header="Firma Türü" body={firmaTuruTemplate} />
            <Column field="touch_date" header="Değişiklik Tarihi" body={firmaDateTemplate} />
          </DataTable>
        </Dialog>
      }
      {
        previewTahsisBelge && <Dialog header={'Tahsis Uzatma Belgesi'} className="ruhsat-dialog" visible={previewTahsisBelge} modal={false} onHide={() => { setPreviewTahsisBelge(false); }}>
          <div className="pdf-container">
            {previewTahsisBelge && tahsisUzatmaBelgesi.map((belge: any) => <iframe src={`data:application/pdf;base64,${belge}`} title="pdf" width="600" height="800"></iframe>)}
          </div>
        </Dialog>
      }
      {
        previewRuhsatBelge && <Dialog header={'Ruhsat Uzatma Belgesi'} className="ruhsat-dialog" visible={previewRuhsatBelge} modal={false} onHide={() => { setPreviewRuhsatBelge(false); }}>
          <div className="pdf-container">
            {previewRuhsatBelge && ruhsatUzatmaBelgesi.map((belge: any) => <iframe src={`data:application/pdf;base64,${belge}`} title="pdf" width="600" height="800"></iframe>)}
          </div>
        </Dialog>
      }
      <ConfirmDialog />
      <Toast ref={toast} />
      {
        editToast &&
        <div className='cont'>
          <div className='warningg'>
            <div style={{ position: 'absolute', top: '1.5em', right: '2em', cursor: 'pointer' }} >
              <i className="pi pi-times" style={{ color: 'white' }} onClick={() => setEditToast(false)}></i>
            </div>
            <div className="flex flex-column" style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
              <div style={{ display: 'flex', alignItems: 'center' }} >
                <div>
                  <i className="pi pi-info-circle" style={{ fontSize: '3rem', marginRight: '0.5em' }}></i>
                </div>
                <div>
                  <p style={{ fontSize: '17px' }}> Parsel bilgilerini güncellemektesiniz. Lütfen bilgilerin doğruluğundan emin olduğunuz taktirde güncellemeyi gerçekleştirin.
                  </p>
                </div>
              </div>
              <div className='group' >
                <Checkbox inputId='info' onChange={(e) => setCheckboxStatus(!checkboxStatus)} checked={checkboxStatus}></Checkbox>
                <label htmlFor='info' style={{ marginLeft: '8px', cursor: 'pointer' }} className='p-checkbox-label'>Okudum, anladım. Onaylıyorum.</label>
              </div>
              <div style={{ display: 'flex', justifyContent: 'center', marginTop: '1em' }}>
                <Button disabled={!checkboxStatus} type="button" label="Tamam" className="ok-button" onClick={hideToast} />
              </div>
            </div>
          </div>
        </div>
      }
      {addFirmVisibility && <AddFirm feature={feature} getFirmaInfo={getFirmaInfo} fields={fields} />}
    </>
  )
}


